import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  FormGroup,
  Paper,
  Typography,
  Button,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField,
  Switch,
  FormControlLabel,
  Dialog,
  Table,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { preventDoubleClick } from "./preventDC.js";
import GetRole from "./user";
import { useEffect, useState } from "react";
import DateCalc, {
  getconvdate,
  airportlist,
  getprofit,
  removeDuplicates,
} from "./date";
import Loading from "./loading";
import { Calendar } from "primereact/calendar";
import {
  sortByKey,
  DateCalc2,
  total,
  pending,
  supplierpending,
  getISOstring,
  getstate,
  getnextpaymentdate,
  getnextpaymentamount,
  geturgent,
  groupBy,
  sptotal,
} from "./date";
import { CSVLink } from "react-csv";
import {
  fetchConvertedTripsOnly,
  fetchSuppliers,
  fetchTripbyId,
  updateTripdata,
  fetchConvertedTripsbyTourid,
  notrecohotel,
  fetchConvertedTripsbyTripOwner,
  fetchConvertedTripsbyTL,
  fetchTaskbycreateddate,
  searchConvTripsbyStartDate,
  fetchtaskbytripid,
  fetchConvertedTripsbyHotelid,
} from "../api/customerapi";
import { DataTable } from "primereact/datatable";
import { useAppData } from "./appDataContext.js";
import { Column } from "primereact/column";
import "primereact/resources/themes/saga-blue/theme.css"; // Theme CSS
import "primereact/resources/primereact.min.css"; // Core CSS

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 10,
  },
  stickyRow: {
    position: "sticky",
    top: "0",
    zIndex: "2",
  },
}));

const PostSales = () => {
  const classes = useStyles();
  const width = window.innerWidth - 200;
  const [value, setValue] = useState(0);
  const columns = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "trip_end_date",
      headerName: "Trip End Date",
      width: (width / 12) * 1,
    },

    {
      field: "all_good",
      headerName: "DC?",
      width: (width / 12) * 0.75,
    },

    {
      field: "book_flight",
      headerName: "Flight Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_hotel",
      headerName: "Hotel Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_land",
      headerName: "Land Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_visa",
      headerName: "Visa Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_insurance",
      headerName: "Insurance Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_add",
      headerName: "Add. Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "vm",
      headerName: "Voucher Matched",
      width: (width / 12) * 0.75,
    },
    {
      field: "ve",
      headerName: "Voucher Explained",
      width: (width / 12) * 0.75,
    },
    {
      field: "inv",
      headerName: "Invoice Name Matched",
      width: (width / 12) * 0.75,
    },
    {
      field: "fup_date",
      headerName: "Fup Date",
      width: (width / 12) * 1,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Converted On",
      width: (width / 12) * 1,
    },
    {
      field: "accepted_date",
      headerName: "Accepted On",
      width: (width / 12) * 1,
    },

    // {
    //   field: 'flight',
    //   headerName: 'Flight Done',
    //   width: width/12*1,
    // },
  ];

  const columns2 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },

    {
      field: "flight_ticket",
      headerName: "Flight Ticket",
      width: (width / 12) * 0.75,
    },
    {
      field: "hotel_voucher",
      headerName: "Hotel Voucher",
      width: (width / 12) * 0.75,
    },
    {
      field: "land_voucher",
      headerName: "Land Voucher",
      width: (width / 12) * 0.75,
    },
    {
      field: "visa",
      headerName: "Visa",
      width: (width / 12) * 0.75,
    },
    {
      field: "driver_number",
      headerName: "Driver Number",
      width: (width / 12) * 0.75,
    },
    {
      field: "briefing_call",
      headerName: "Briefing Call",
      width: (width / 12) * 0.75,
    },
    {
      field: "wa_group",
      headerName: "WG",
      width: (width / 12) * 0.75,
    },
    {
      field: "check_in",
      headerName: "Check In",
      width: (width / 12) * 0.75,
    },
    {
      field: "trip_end_date",
      headerName: "Trip End Date",
      width: (width / 12) * 1,
    },
    {
      field: "fup_date",
      headerName: "Fup Date",
      width: (width / 12) * 0.75,
    },

    {
      field: "conv_date",
      headerName: "Converted On",
      width: (width / 12) * 1,
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },
    {
      field: "vacation_list",
      headerName: "Vacation List",
      width: (width / 12) * 0.75,
    },
    {
      field: "help_doc",
      headerName: "Help Document",
      width: (width / 12) * 0.75,
    },
    {
      field: "flight_status",
      headerName: "Flight Status",
      width: (width / 12) * 0.75,
    },
    {
      field: "refund",
      headerName: "Refund Due",
      width: (width / 12) * 1,
    },
    {
      field: "risk",
      headerName: "Risk",
      width: (width / 12) * 1,
    },
    {
      field: "next_date",
      headerName: "Next Date",
      width: (width / 12) * 1,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) * 1,
    },
  ];

  const columns3 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "total",
      headerName: "Total",
      width: (width / 12) * 1,
    },
    {
      field: "received",
      headerName: "Received",
      width: (width / 12) * 1,
    },
    {
      field: "pending",
      headerName: "Pending",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_hotel",
      headerName: "Hotel Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_land",
      headerName: "Land Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "double_check",
      headerName: "DC",
      width: (width / 12) * 0.75,
    },
    {
      field: "vm",
      headerName: "Voucher Matched",
      width: (width / 12) * 0.75,
    },
    {
      field: "ve",
      headerName: "Voucher Explained",
      width: (width / 12) * 0.75,
    },
    {
      field: "driver",
      headerName: "Driver",
      width: (width / 12) * 0.75,
    },
    {
      field: "bc",
      headerName: "Briefing Call",
      width: (width / 12) * 0.75,
    },
    {
      field: "pm",
      headerName: "Preventive Messages",
      width: (width / 12) * 0.75,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "inv",
      headerName: "Invoice Name Matched",
      width: (width / 12) * 0.75,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "supplier_pending",
      headerName: "Supp. Pending",
      width: (width / 12) * 1,
    },
    {
      field: "vm_date",
      headerName: "VM Date",
      width: (width / 12) * 1,
    },
  ];

  const columns4 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },

    {
      field: "total",
      headerName: "Total",
      width: (width / 12) * 1,
    },
    {
      field: "received",
      headerName: "Received",
      width: (width / 12) * 1,
    },

    {
      field: "flight",
      headerName: "Flight",
      width: (width / 12) * 1,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) * 1,
    },

    {
      field: "pending",
      headerName: "Pending",
      width: (width / 12) * 0.75,
    },

    {
      field: "sales",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "next_payment_date",
      headerName: "Next Payment Date",
      width: (width / 12) * 1,
    },
    {
      field: "installment_amount",
      headerName: "Installment Amount",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "flight_ticket",
      headerName: "Flight Ticket",
      width: (width / 12) * 1,
    },
    {
      field: "risk_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },

    {
      field: "risk_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
    {
      field: "risk_comment_3",
      headerName: "Comment 3",
      width: (width / 12) * 4,
    },
  ];

  const columns5 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "book_flight",
      headerName: "Flight Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_hotel",
      headerName: "Hotel Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_land",
      headerName: "Land Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "apply_visa",
      headerName: "Visa Applied",
      width: (width / 12) * 0.75,
    },
    {
      field: "apply_date",
      headerName: "Applied Date",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_visa",
      headerName: "Visa Book",
      width: (width / 12) * 0.75,
    },

    {
      field: "sales",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "upsell_ops_owner",
      headerName: "Upsell Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "supplier",
      headerName: "Supplier",
      width: (width / 12) * 1,
    },
    {
      field: "visa_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "visa_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
  ];

  const columns5c = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 2,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },

    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },
    {
      field: "extra",
      headerName: "Available Amount",
      width: (width / 12) * 1,
    },
    {
      field: "supplier_name",
      headerName: "Supplier Name",
      width: (width / 12) * 1,
    },
  ];

  const columns5d = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 2,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },

    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },

    {
      field: "airlines",
      headerName: "Airlines",
      width: (width / 12) * 1,
    },
  ];

  const columns5b = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "book_flight",
      headerName: "Flight Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_hotel",
      headerName: "Hotel Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "book_land",
      headerName: "Land Book",
      width: (width / 12) * 0.75,
    },
    {
      field: "apply_visa",
      headerName: "Visa Applied",
      width: (width / 12) * 0.75,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) * 0.75,
    },
    {
      field: "pending",
      headerName: "Pending",
      width: (width / 12) * 0.75,
    },
    {
      field: "hold_ops_date",
      headerName: "Hold Ops Date",
      width: (width / 12) * 1,
    },
    {
      field: "sales",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "whatsapp",
      headerName: "WA Group",
      width: (width / 12) * 1,
    },
    {
      field: "hold_ops_reason",
      headerName: "Hold Ops Reason",
      width: (width / 12) * 3,
    },
  ];

  const columns6 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    // {
    //   field: 'notes',
    //   headerName: 'Notes',
    //   width: width/12*3,
    // },
    {
      field: "notes2",
      headerName: "Notes",
      width: (width / 12) * 3,
    },

    {
      field: "sales",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12) * 1,
    },
    {
      field: "pending_on",
      headerName: "Pending On",
      width: (width / 12) * 1,
    },
  ];

  const columns7 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "passport",
      headerName: "Passport",
      width: (width / 12) * 1,
    },
    {
      field: "pan",
      headerName: "Pan",
      width: (width / 12) * 0.75,
    },
    {
      field: "aadhaar",
      headerName: "Aadhaar",
      width: (width / 12) * 0.75,
    },
    {
      field: "return_tickets",
      headerName: "Tickets",
      width: (width / 12) * 1,
    },
    {
      field: "pc",
      headerName: "Passport Checked",
      width: (width / 12) * 0.75,
    },
    {
      field: "pna",
      headerName: "PNA",
      width: (width / 12) * 0.75,
    },

    {
      field: "double_check",
      headerName: "DC",
      width: (width / 12) * 0.75,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) * 0.75,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "ops_status",
      headerName: "Ops Status",
      width: (width / 12) * 1,
    },
    {
      field: "on_hold",
      headerName: "On Hold",
      width: (width / 12) * 1,
    },
    {
      field: "docs_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "docs_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
  ];

  const columns8 = [
    {
      field: "task_id",
      headerName: " Task ID",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
    },

    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: (width / 12) * 1,
    },
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "assigned_by",
      headerName: "Assigned By",
      width: (width / 12) * 1,
    },
    {
      field: "task_status",
      headerName: "Status",
      width: (width / 12) * 1,
    },
    {
      field: "task_priority",
      headerName: "Priority",
      width: (width / 12) * 1,
    },
    {
      field: "task_category",
      headerName: "Category",
      width: (width / 12) * 1,
    },
    {
      field: 'wrong_ticket',
      headerName: 'Wrong Ticket',
      width: width/12*1,
    },
    {
      field: "days_elapsed",
      headerName: "Days Elapsed",
      width: (width / 12) * 1,
    },
    {
      field: "task_deadline",
      headerName: "Time to deadline",
      width: (width / 12) * 1,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: (width / 12) * 1,
    },
    {
      field: "assignedby_team",
      headerName: "Pending From",
      width: (width / 12) * 1,
    },
    {
      field: "assignedto_team",
      headerName: "Pending On",
      width: (width / 12) * 1,
    },
  ];

  const columns8b = [
    {
      field: "team",
      headerName: " Team",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
    },

    {
      field: "open",
      headerName: "Open",
      width: width / 12,
    },
    {
      field: "inprogress",
      headerName: "In Progress",
      width: width / 12,
      cellClassName: "gridcell",
    },
    {
      field: "waiting",
      headerName: "Waiting",
      width: width / 12,
    },
    {
      field: "b2o",
      headerName: "B2O",
      width: width / 12,
    },
    {
      field: "taskdone",
      headerName: "Task Done",
      width: width / 12,
    },
    {
      field: "total",
      headerName: "Total",
      width: width / 12,
    },
  ];

  const columns8c = [
    {
      field: "name",
      headerName: "Team",
      width: width / 12,
      cellClassName: "gridcell",
    },

    {
      field: "count",
      headerName: "Count",
      width: width / 12,
    },
    {
      field: "closed",
      headerName: "Closed",
      width: width / 12,
    },
    {
      field: "avg_close_time",
      headerName: "Avg. CLose (Hours)",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
    },
    {
      field: "avg_resolution_time",
      headerName: "Avg. Resolution (Hours)",
      width: (width / 12) * 2,
    },
  ];

  const columns11 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },

    {
      field: "transfer_state",
      headerName: "State",
      width: (width / 12) * 0.75,
    },

    {
      field: "hold_ops_date",
      headerName: "Hold Ops Date",
      width: (width / 12) * 1,
    },
    {
      field: "sales",
      headerName: "Trip Owner",
      width: (width / 12) * 1,
    },
    {
      field: "pending",
      headerName: "Pending",
      width: (width / 12) * 1,
    },

    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "whatsapp",
      headerName: "WA Group",
      width: (width / 12) * 1,
    },
    {
      field: "b2s_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "b2s_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
  ];

  const columns12b = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "cut_off",
      headerName: "Cut Off",
      width: (width / 12) * 1,
    },
    {
      field: "supplier",
      headerName: "Supplier",
      width: (width / 12) * 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },
  ];

  const columns12 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "upsell_ops_owner",
      headerName: "Upsell Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "upsell_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "upsell_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
  ];

  const columns12c = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) * 1,
    },
    {
      field: "pax",
      headerName: "Pax",
      width: (width / 12) * 1,
    },
    {
      field: "ops_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "ops_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
    {
      field: "hbd",
      headerName: "Hotel_Booked_On",
      width: width / 12,
    },
    {
      field: "lbd",
      headerName: "Land_Booked_On",
      width: width / 12,
    },
  ];

  const columns14 = [
    {
      field: "trip_id",
      headerName: " Trip Id",
      width: (width / 12) * 0.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "cust_name",
      headerName: "Name",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "primary_destination",
      headerName: "Primary Destination",
      width: (width / 12) * 1,
    },
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) * 1,
    },
    {
      field: "trip_end_date",
      headerName: "End Date",
      width: (width / 12) * 1,
    },
    {
      field: "og_comment_1",
      headerName: "Comment 1",
      width: (width / 12) * 4,
    },
    {
      field: "og_comment_2",
      headerName: "Comment 2",
      width: (width / 12) * 4,
    },
  ];

  const headers = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Total", key: "total" },
    { label: "Flight", key: "flight" },
    { label: "Total Received Amount", key: "received" },
    { label: "Installment Date", key: "installment_date" },
    { label: "Installment Amount", key: "installment_amount" },
    { label: "Total Pending Amount", key: "pending" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "TL", key: "tl" },
    { label: "Trip Owner", key: "sales" },
    { label: "Ops Owner", key: "ops_owner" },
  ];

  const headers2 = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Trip Owner", key: "sales" },
    { label: "Ops Owner", key: "ops_owner" },
    { label: "Status", key: "status" },
    { label: "Pending On", key: "pending_on" },
    { label: "Notes", key: "notes" },
  ];

  const headers2b = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Ops Owner", key: "ops_owner" },
    { label: "Flight Ticket", key: "flight_ticket" },
    { label: "Hotel Voucher", key: "hotel_voucher" },
    { label: "Land Voucher", key: "land_voucher" },
    { label: "Visa", key: "visa" },
    { label: "Driver Number", key: "driver_number" },
    { label: "End Date", key: "trip_end_date" },
    { label: "Check In", key: "check_in" },
    { label: "Vacation List", key: "vacation_list" },
    { label: "Trip Owner", key: "trip_owner" },
    { label: "Conv Date", key: "conv_date" },
    { label: "Fup Date", key: "fup_date" },
    { label: "WA Group", key: "wa_group" },
    { label: "Briefing Call", key: "briefing_call" },
    { label: "Refund", key: "refund" },
    { label: "Flight Status", key: "flight_status" },
    { label: "Help Doc", key: "help_doc" },
    { label: "Risk", key: "risk" },
    { label: "Next Date", key: "next_date" },
    { label: "Profit", key: "profit" },
  ];

  const headers3 = [
     { label: "Trip Id", key: "trip_id" },
     { label: "Name", key: "cust_name" },
     { label: "Destination", key: "primary_destination" },
     { label: "Start Date", key: "trip_start_date" },
     { label: "End Date", key: "trip_end_date" },
     { label: "FUP Comment", key: "fup_comment" },
     { label: "Ops Owner", key: "ops_owner" },
     { label: "All good", key: "all_good" },
     { label: "Flight", key: "book_flight" },
     { label: "Hotel", key: "book_hotel" },
     { label: "Land", key: "book_land" },
     { label: "Visa", key: "book_visa" },
     { label: "Insurance", key: "book_insurance" },
     { label: "Additional", key: "book_add" },
     { label: "Advance Booking", key: "advance_booking" },
     { label: "Hotel Booking Date", key: "hotel_booking_date" },
     { label: "Hotel Pitch", key: "hp" },
     { label: "Briefing Call", key: "bc" },
     { label: "Task", key: "task" },
     { label: "Voucher Matched", key: "vm" },
     { label: "Voucher Explained", key: "ve" },
     { label: "Invoice", key: "inv" },
     { label: "Conv Date", key: "conv_date" },
     { label: "Accepted Date", key: "accepted_date" },
     { label: "Fup Date", key: "fup_date" },
     { label: "Trip Owmer", key: "trip_owner" },
     { label: "Upsell Ops", key: "upsell_ops_owner" },
  ];

  const headers3b = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Total", key: "total" },
    { label: "Received", key: "received" },

    { label: "Pending", key: "pending" },
    { label: "Ops Owner", key: "ops_owner" },
    { label: "Driver", key: "driver" },
    { label: "Hotel", key: "book_hotel" },
    { label: "Land", key: "book_land" },
    { label: "DC", key: "double_check" },
    { label: "Supplier Pending", key: "supplier_pending" },
    { label: "VM Date", key: "vm_date" },
    { label: "Voucher Matched", key: "vm" },
    { label: "Voucher Explained", key: "ve" },
    { label: "Invoice", key: "inv" },
    { label: "Conv Date", key: "conv_date" },
    { label: "Preventive", key: "pm" },
    { label: "Briefing Call", key: "bc" },
  ];

  const headers5 = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Flight", key: "book_flight" },
    { label: "Hotel", key: "book_hotel" },
    { label: "Land", key: "book_land" },
    { label: "Visa Applied", key: "apply_visa" },
    { label: "Applied Date", key: "apply_date" },
    { label: "Visa Received", key: "book_visa" },
    { label: "Trip Owmer", key: "sales" },
    { label: "Ops Owmer", key: "ops_owner" },
    { label: "Upsell Owmer", key: "upsell_ops_owner" },
    { label: "WA Group", key: "whatsapp" },
  ];

  const headers6 = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Ops Owmer", key: "ops_owner" },
    { label: "Amount", key: "amount" },
    { label: "Supplier Name", key: "supplier_name" },
    { label: "Extra", key: "extra" },
  ];

  const headers11 = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Conv On", key: "conv_date" },
    { label: "Hold Ops", key: "hold_ops_date" },
    { label: "State", key: "transfer_state" },
    { label: "Trip Owmer", key: "sales" },
    { label: "Ops Owmer", key: "ops_owner" },
    { label: "WA Group", key: "whatsapp" },
    { label: "Comment 1", key: "b2s_comment_1" },
    { label: "Comment 2", key: "b2s_comment_2" },
  ];

  const headers12 = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Conv On", key: "conv_date" },
    { label: "Upsell Owmer", key: "upsell_ops_owner" },
    { label: "Ops Owmer", key: "ops_owner" },

    { label: "Comment 1", key: "upsell_comment_1" },
    { label: "Comment 2", key: "upsell_comment_2" },
  ];

  const headers12b = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Ops Owner", key: "ops_owner" },
    { label: "Cut Off", key: "cut_off" },
    { label: "Supplier", key: "supplier" },
    { label: "Amount", key: "amount" },
  ];

  const headers12c = [
    { label: "Trip Id", key: "trip_id" },
    { label: "Name", key: "cust_name" },
    { label: "Destination", key: "primary_destination" },
    { label: "Start Date", key: "trip_start_date" },
    { label: "Conv On", key: "conv_date" },

    { label: "Ops Owmer", key: "ops_owner" },

    { label: "Comment 1", key: "ops_comment_1" },
    { label: "Comment 2", key: "ops_comment_2" },
  ];

  const headers8 = [
    { label: "Task Id", key: "task_id" },
    { label: "Assigned To", key: "assigned_to" },
    { label: "Trip Id", key: "trip_id" },
    { label: "Assigned By", key: "assigned_by" },
    { label: "Status", key: "task_status" },
    { label: "Wrong Ticket", key: "wrong_ticket" },
    { label: "Priority", key: "task_priority" },
    { label: "Days Elapsed", key: "days_elapsed" },
    { label: "Category", key: "task_category" },
    { label: "Time Elapsed", key: "time_elapsed" },
    { label: "Deadline", key: "task_deadline" },
    { label: "Created At", key: "createdAt" },
    { label: "Pending From", key: "assignedby_team" },
    { label: "Pending On", key: "assignedto_team" },
  ];

  const [listtripData, setlisttripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData2, setlisttripData2] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [selection, setselection] = useState([]);
  const [selection2, setselection2] = useState([]);
  const [selection3, setselection3] = useState([]);
  const [selection4, setselection4] = useState([]);
  const [selection11, setselection11] = useState([]);
  const [selection12, setselection12] = useState([]);
  const [selection14, setselection14] = useState([]);
  const [selection15, setselection15] = useState([]);
  const [sData, setsData] = useState([]);
  const [forcerender, setforcerender] = useState(false);
  const [multiSortMeta, setMultiSortMeta] = useState([]);
  const [refresh, setrefresh] = useState(0);
  const [mainTab, setMainTab] = useState(0);
  const [subTab, setSubTab] = useState(0);
  const [filters, setFilters] = useState(null);
  const [isOwner, setisOwner] = useState(true);
  const [working, setworking] = useState(false);
  const [showfilter, setshowfilter] = useState(false);
  const [showtrips, setshowtrips] = useState(false);
  const [Open19, setOpen19] = useState(false);
  const [summarydata, setsummarydata] = useState(false);
  const [leadfilterData, setleadfilterData] = useState({});
  const [leadfilterData2, setleadfilterData2] = useState({});
  const [leadfilterData3, setleadfilterData3] = useState({});
  const [leadfilterData4, setleadfilterData4] = useState({});
  const [leadfilterData5, setleadfilterData5] = useState({});
  const [leadfilterData6, setleadfilterData6] = useState({});
  const [startdatecount, setstartdatecount] = useState(null);
  const [emp, setemp] = useState([]);
  const [tlemp, settlemp] = useState([]);
  const [emp2, setemp2] = useState([]);
  const [empall, setempall] = useState([]);
  const [tasklist, settasklist] = useState([]);
  const [alltasklist, setalltasklist] = useState([]);
  const [tasklist2, settasklist2] = useState([]);
  const [searchData8, setsearchData8] = useState({});
  const [showalltasks, setshowalltasks] = useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    hiddenColumnKey: false, // Set to false to hide the column initially
  });
  const [columnVisibilityModel2, setColumnVisibilityModel2] = useState({
    hiddenColumnKey: false, // Set to false to hide the column initially
  });
  const [columnVisibilityModel3, setColumnVisibilityModel3] = useState({
    hiddenColumnKey: false, // Set to false to hide the column initially
  });
  const [columnVisibilityModel4, setColumnVisibilityModel4] = useState({
    hiddenColumnKey: false, // Set to false to hide the column initially
  });
  //const { appData, loading } = useAppData();
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const airportlist2 = airportlist.sort((a, b) => (a.city > b.city ? 1 : -1));
  // const initFilters = () => {
  //   setFilters({
  //       global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //       name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  //       'country.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  //       representative: { value: null, matchMode: FilterMatchMode.IN },
  //       date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
  //       balance: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
  //       status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
  //       activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
  //       verified: { value: null, matchMode: FilterMatchMode.EQUALS }
  //   });
  //   setGlobalFilterValue('');
  // };

  const getconvtrips = async () => {
    try {
      var result3 = [];
      if (showtrips) {
        setworking(true);
        const data = await fetchConvertedTripsOnly();
        setlisttripData(data.data);
        result3 = groupBy(data.data, (v) => v.trip_start_date);
        setworking(false);
      } else {
        setworking(true);
        const data = await searchConvTripsbyStartDate(
          DateCalc(-7),
          DateCalc(90),
        );
        //console.log(data.data)
        setlisttripData(data.data.filter((t) => t.trip_status == "Converted"));
        result3 = groupBy(data.data, (v) => v.trip_start_date);
        setworking(false);
      }
      //console.log(result3)
      const resultobject = {};
      for (let [key, value] of result3) {
        resultobject[key] = value.length;
      }
      //console.log(resultobject)
      setstartdatecount(resultobject);
    } catch (err) {
      console.log(err);
    }
  };

  const getconvtrips2 = async () => {
    try {
      var result3 = [];

      setworking(true);
      const data = await searchConvTripsbyStartDate(
        DateCalc(-10),
        DateCalc(365),
      );
      //console.log(data.data)
      setlisttripData(data.data.filter((t) => t.trip_status == "Converted"));
      result3 = groupBy(data.data, (v) => v.trip_start_date);
      setworking(false);

      //console.log(result3)
      const resultobject = {};
      for (let [key, value] of result3) {
        resultobject[key] = value.length;
      }
      //console.log(resultobject)
      setstartdatecount(resultobject);
    } catch (err) {
      console.log(err);
    }
  };

  const getTripsbyTripOwner = async (owner) => {
    try {
      //console.log(owner)
      const data = await fetchConvertedTripsbyTripOwner(owner);
      setlisttripData(data.data);
    } catch (err) {
      console.log(err);
    }
    //console.log(followupData)
  };

  const getTripsbyTL = async (owner) => {
    try {
      //console.log(owner)
      const data = await fetchConvertedTripsbyTL(owner);
      setlisttripData(data.data);
    } catch (err) {
      console.log(err);
    }
    //console.log(followupData)
  };

  const getEmployees = async () => {
    try {
      // const data = await fetchEmployees();
      // setempall(data.data)
      setempall(employeelist);
      const empsplist = employeelist.filter(
        (emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME",
      );
      const empshortname = empsplist.map((emp) => emp.short_name);
      const empsplist2 = employeelist.filter(
        (emp) =>
          emp.role == "Operations" ||
          emp.role == "TL" ||
          emp.role == "Product" ||
          emp.role == "Operations-TL",
      );
      const empshortname2 = empsplist2.map((emp) => emp.short_name);
      let sortedemp = empshortname.sort();
      setemp(sortedemp);
      //setemp(empshortname);
      setemp2(empshortname2);
      const emptllist = employeelist.filter((emp) => emp.role == "TL");
      const emptlshortname = emptllist.map((emp) => emp.short_name);
      settlemp(emptlshortname);
    } catch (err) {
      console.log(err);
    }
  };

  const getTeam = (emp) => {
    const x = empall.filter((e) => e.short_name == emp);
    return x && x.length > 0 && "role" in x[0] ? x[0].role : "";
  };

  const getsuppliers = async () => {
    try {
      //console.log(tripData.primary_destination)
      //const data = await fetchSuppliersbyDest(tripData.primary_destination);
      const data = await fetchSuppliers();

      setsData(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getallgood = (trip) => {
    let flag = 0;
    if ("supplier_payments" in trip && trip.supplier_payments.length > 0) {
      for (let i = 0; i < trip.supplier_payments.length; i++) {
        if (!trip.supplier_payments[i].all_good) {
          flag = 1;
        }
      }
      if (flag) {
        return "No";
      } else {
        return "Yes";
      }
    } else {
      return "No";
    }
  };

  const getpna = (trip) => {
    let flag = 0;
    for (let i = 0; i < trip.supplier_payments.length; i++) {
      if (!trip.supplier_payments[i].pna) {
        flag = 1;
      }
    }
    if (flag) {
      return false;
    } else {
      return true;
    }
  };

  const getsuppliertype = (name) => {
    const type = sData.filter((sup) => sup.supplier_name == name);
    //console.log(type)
    return type.length > 0 ? type[0].supplier_type : "";
  };

  const getList = async () => {
    const two = DateCalc(2);
    //const data=await fetchfutureconvTrips()
    const data = await fetchConvertedTripsOnly();
    //console.log(tripData.length)
    const tripData2 = data.data.filter(
      (trip) =>
        trip.trip_status !== "Closed" &&
        "booking" in trip &&
        "follow_up_date_text" in trip.booking &&
        new Date(trip.booking.follow_up_date_text).getTime() <=
          new Date(two).getTime(),
    );
    setlisttripData2(tripData2);
  };

  useEffect(() => {
    getEmployees();
    getsuppliers();

    if (cuser && role) {
      //role == "Admin"  ? getconvtrips() : getTripsbyTripOwner(cuser)
      if (
        role == "TL" ||
        role == "Support" ||
        role == "Operations" ||
        role == "Operations-TL" ||
        role == "Manager" ||
        role == "Accounts"
      ) {
        getconvtrips();
        fetchtasksbydate();
      } else if (role == "Sales" || role == "SME") {
        getTripsbyTripOwner(cuser);
        fetchtasksbydate();
      } else {
        getconvtrips2();
        fetchtasksbydate();
      }
    }
  }, [loading, cuser, role, employeelist, destinationlist]);

  useEffect(() => {
    getconvtrips();
  }, [showtrips]);

  const changeisOwner = () => {
    setisOwner(!isOwner);
    if (!isOwner) {
      role = "Sales";
    } else {
      role = "Admin";
    }
    //role == "Admin"  ? getTrips() : getTripsbyTripOwner(cuser)
  };

  const changeshowfilter = () => {
    setshowfilter(!showfilter);

    //role == "Admin"  ? getTrips() : getTripsbyTripOwner(cuser)
  };

  const changeshowtrips = () => {
    setshowtrips(!showtrips);

    //role == "Admin"  ? getTrips() : getTripsbyTripOwner(cuser)
  };

  const getvisasupplier = (trip) => {
    var ret = "";
    if ("supplier_payments" in trip && trip.supplier_payments.length > 0) {
      const temp = trip.supplier_payments.filter(
        (sp) => getsuppliertype(sp.name) == "Visa agency",
      );
      if (temp.length > 0) {
        ret = temp[0].name;
      }
    }
    return ret;
  };

  const getcomment = (trip, type, c) => {
    var ret = "";

    // if(trip.trip_id==117592){
    //   console.log(type, c)

    const length = "tl_comment" in trip ? trip.tl_comment.length : 0;
    if (length >= c) {
      // console.log(length)
      for (let i = length - c; i >= 0; i--) {
        // console.log(count)
        if (
          trip.tl_comment[i].status == type &&
          trip.tl_comment[i].comment_date
        ) {
          // console.log(trip.tl_comment[i].comment)
          ret =
            trip.tl_comment[i].comment_date.split("T").slice(0, 1) +
            ": " +
            trip.tl_comment[i].comment;
          //ret=trip.tl_comment[i].comment
          break;
        }
      }
    }
    // }

    return ret;
  };

  const handleChange2 = () => {
    setshowalltasks(!showalltasks);
  };

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
    setSubTab(0);
    // reset sub tab whenever main tab changes
  };

  const handleSubTabChange = (event, newValue) => {
    setSubTab(newValue);
    if (mainTab == 2 && newValue == 1) {
      fetchtasksbydate();
    }
  };

  const handleClose19 = () => {
    setOpen19(false);
  };

  var tendays = DateCalc(-10);
  var l1 = [...listtripData];
  if (leadfilterData.trip_owner) {
    l1 = l1.filter(
      (tripdata) => tripdata.trip_owner == leadfilterData.trip_owner,
    );
  }
  if (leadfilterData.ops_owner) {
    l1 = l1.filter(
      (tripdata) =>
        "booking" in tripdata &&
        "ops_assigned" in tripdata.booking &&
        tripdata.booking.ops_assigned == leadfilterData.ops_owner,
    );
  }

  //l1=l1.filter(tripdata => tripdata.trip_status=="Converted")
  if (leadfilterData.flight_ticket) {
    l1 = l1.filter(
      (tripdata) => tripdata.flight_ticket == leadfilterData.flight_ticket,
    );
  }
  if (leadfilterData.hotel_voucher) {
    l1 = l1.filter(
      (tripdata) => tripdata.hotel_voucher == leadfilterData.hotel_voucher,
    );
  }
  if (leadfilterData.land_voucher) {
    l1 = l1.filter(
      (tripdata) => tripdata.land_voucher == leadfilterData.land_voucher,
    );
  }
  if (leadfilterData.visa) {
    l1 = l1.filter((tripdata) => tripdata.visa == leadfilterData.visa);
  }
  if (leadfilterData.check_in) {
    l1 = l1.filter((tripdata) => tripdata.check_in == leadfilterData.check_in);
  }
  if (leadfilterData.driver_number) {
    l1 = l1.filter(
      (tripdata) => tripdata.driver_number == leadfilterData.driver_number,
    );
  }
  if (leadfilterData.vacation_list) {
    l1 = l1.filter(
      (tripdata) => tripdata.vacation_list == leadfilterData.vacation_list,
    );
  }
  if (leadfilterData.help_doc) {
    l1 = l1.filter((tripdata) => tripdata.help_doc == leadfilterData.help_doc);
  }
  if (leadfilterData.flight_status) {
    l1 = l1.filter(
      (tripdata) => tripdata.flight_status == leadfilterData.flight_status,
    );
  }
  if (leadfilterData.trip_model) {
    l1 = l1.filter(
      (tripdata) => tripdata.trip_model == leadfilterData.trip_model,
    );
  }
  if (leadfilterData.no_tax) {
    if (leadfilterData.no_tax == "No") {
      l1 = l1.filter((tripdata) => tripdata.no_tax !== true);
    } else {
      l1 = l1.filter((tripdata) => tripdata.no_tax);
    }
  }
  if (leadfilterData.only_flight) {
    l1 = l1.filter((tripdata) => tripdata.only_flight);
  }
  if (leadfilterData.lead_source_airport) {
    l1 = l1.filter(
      (tripdata) =>
        tripdata.lead_source_airport == leadfilterData.lead_source_airport,
    );
  }
  if (leadfilterData.transfer_status) {
    if (leadfilterData.transfer_status == "Non B2S") {
      l1 = l1.filter(
        (tripdata) =>
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Just Converted"),
      );
    } else {
      l1 = l1.filter(
        (tripdata) =>
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          tripdata.booking.transfer_state == leadfilterData.transfer_status,
      );
    }
  }
  if (leadfilterData.future_trips) {
    if (leadfilterData.future_trips == "Without JC") {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted"),
      );
    } else {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true,
      );
    }
  }
  if (leadfilterData.threedays) {
    l1 = l1.filter(
      (tripdata) =>
        tripdata.on_hold !== true &&
        "booking" in tripdata &&
        "transfer_state" in tripdata.booking &&
        (tripdata.booking.transfer_state == "Requested" ||
          tripdata.booking.transfer_state == "Accepted" ||
          tripdata.booking.transfer_state == "Just Converted") &&
        tripdata.hold_ops !== true &&
        new Date(getconvdate(tripdata)).getTime() <
          new Date(DateCalc(-3)).getTime(),
    );
  }
  if (leadfilterData.bc) {
    if (leadfilterData.bc == "Not Attempted") {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          !("briefing_call" in tripdata.booking),
      );
    } else {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          tripdata.booking.briefing_call == leadfilterData.bc,
      );
    }
  }
  if (leadfilterData.hp) {
    if (leadfilterData.hp == "Not Attempted") {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          !("hotel_pitch" in tripdata.booking),
      );
    } else {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          tripdata.booking.hotel_pitch == leadfilterData.hp,
      );
    }
  }
  if (leadfilterData.invoice) {
    if (leadfilterData.invoice == "7 Days") {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          new Date(getconvdate(tripdata)).getTime() >
            new Date(DateCalc(-7)).getTime() &&
          new Date(tripdata.trip_start_date).getTime() >
            new Date("2025-12-01").getTime() &&
          !(
            tripdata.booking.invoice_name_matched == "Yes" ||
            tripdata.booking.invoice_name_matched == "NA"
          ),
      );
    } else {
      l1 = l1.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true &&
          new Date(tripdata.trip_start_date).getTime() >
            new Date("2025-12-01").getTime() &&
          !(
            tripdata.booking.invoice_name_matched == "Yes" ||
            tripdata.booking.invoice_name_matched == "NA"
          ),
      );
    }
  }
  if (leadfilterData.double_check) {
    l1 = l1.filter(
      (tripdata) => getallgood(tripdata) == leadfilterData.double_check,
    );
  }
  const pastthreedays = DateCalc(-3);

  l1 = sortByKey(l1, "trip_start_date");
  const onedays = DateCalc(1);
  const tendays2 = DateCalc(10);
  const fifteendays = DateCalc(15);
  const pastsevendays = DateCalc(-7);
  const pasttendays = DateCalc(-10);
  var l2 = l1.filter(
    (trip) =>
      new Date(trip.trip_start_date).getTime() <
        new Date(fifteendays).getTime() &&
      new Date(trip.trip_start_date).getTime() >
        new Date(pasttendays).getTime(),
  );
  var l22 = [...l2];
  var l21 = [...l1];
  if (l21.length > 0 && l2.length > 0) {
    l21 = l1.filter(
      (trip) =>
        pending(trip.cust_payments) !== 0 &&
        new Date(trip.trip_start_date).getTime() < new Date().getTime(),
    );
    //console.log(l21)
    l22 = [...l21, ...l2];
  }

  const findtask = (tripdata) => {
    if (tripdata && tripdata.trip_id) {
      const task = tasklist.filter(
        (t) =>
          t.trip_id == tripdata.trip_id &&
          "assigned_to" in t &&
          t.assigned_to !== "Pawan",
      );
      return task.length > 0 ? task[0].task_id : "";
    } else {
      return "";
    }
  };

  const tripdatalistdisplay = l1.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l1.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    trip_end_date:
      "duration" in tripdata && "trip_start_date" in tripdata
        ? DateCalc2(tripdata.trip_start_date, tripdata.duration)
        : "",
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    trip_owner: tripdata.trip_owner,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    upsell_ops_owner:
      "booking" in tripdata && "upsell_ops_assigned" in tripdata.booking
        ? tripdata.booking.upsell_ops_assigned
        : "",
    fup_date:
      "booking" in tripdata
        ? "fup" in tripdata.booking && tripdata.booking.fup.length > 0
          ? tripdata.booking.fup[tripdata.booking.fup.length - 1].date
          : tripdata.booking.follow_up_date_text
        : "",
    fup_comment:
      "booking" in tripdata
        ? "fup" in tripdata.booking && tripdata.booking.fup.length > 0
          ? tripdata.booking.fup[tripdata.booking.fup.length - 1].note
          : ""
        : "",
    all_good: "supplier_payments" in tripdata ? getallgood(tripdata) : "",
    red_flag: tripdata.red_flag,
    flight_ticket: tripdata.flight_ticket,
    hotel_voucher: tripdata.hotel_voucher,
    land_voucher: tripdata.land_voucher,
    visa: tripdata.visa,
    driver_number: tripdata.driver_number,
    check_in: tripdata.check_in,
    vacation_list: tripdata.vacation_list,
    help_doc: tripdata.help_doc,
    flight_status: tripdata.flight_status,
    book_flight:
      "booking" in tripdata && "flight" in tripdata.booking
        ? tripdata.booking.flight
        : "",
    book_hotel:
      "booking" in tripdata && "hotel" in tripdata.booking
        ? tripdata.booking.hotel
        : "",
    book_land:
      "booking" in tripdata && "land" in tripdata.booking
        ? tripdata.booking.land
        : "",
    book_visa:
      "booking" in tripdata && "visa" in tripdata.booking
        ? tripdata.booking.visa
        : "",
    book_insurance:
      "booking" in tripdata && "insurance" in tripdata.booking
        ? tripdata.booking.insurance
        : "",
    book_add:
      "booking" in tripdata && "others" in tripdata.booking
        ? tripdata.booking.others
        : "",
    vm:
      "booking" in tripdata && "voucher_matched" in tripdata.booking
        ? tripdata.booking.voucher_matched
        : "",
    bc:
      "booking" in tripdata && "briefing_call" in tripdata.booking
        ? tripdata.booking.briefing_call
        : "",
    hp:
      "booking" in tripdata && "hotel_pitch" in tripdata.booking
        ? tripdata.booking.hotel_pitch
        : "",
    task: "trip_id" in tripdata ? findtask(tripdata) : "",
    ve:
      "booking" in tripdata && "voucher_explained" in tripdata.booking
        ? tripdata.booking.voucher_explained
        : "",
    inv:
      "booking" in tripdata && "invoice_name_matched" in tripdata.booking
        ? tripdata.booking.invoice_name_matched
        : "",
    refund:
      "booking" in tripdata && "refund_due" in tripdata.booking
        ? tripdata.booking.refund_due
        : "",
    accepted_date: tripdata.accepted_date,
    advance_booking:
      "booking" in tripdata && "advance_tickets" in tripdata.booking
        ? tripdata.advance_booking + " - " + tripdata.booking.advance_tickets
        : tripdata.advance_booking,
    hotel_booking_date:
      "hotel_booking_date" in tripdata ? tripdata.hotel_booking_date : false,
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
  }));

  const fixedRow1 = tripdatalistdisplay[0]; // Assuming the first row is fixed
  const restRows1 = tripdatalistdisplay.slice(1); // Remaining rows

  const tripdatalistdisplay2 = l1.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l1.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    trip_end_date:
      "duration" in tripdata && "trip_start_date" in tripdata
        ? DateCalc2(tripdata.trip_start_date, tripdata.duration)
        : "",
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    trip_owner: tripdata.trip_owner,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    fup_date:
      "booking" in tripdata
        ? "fup" in tripdata.booking && tripdata.booking.fup.length > 0
          ? tripdata.booking.fup[tripdata.booking.fup.length - 1].date
          : tripdata.booking.follow_up_date_text
        : "",
    flight_ticket: tripdata.flight_ticket,
    hotel_voucher: tripdata.hotel_voucher,
    land_voucher: tripdata.land_voucher,
    visa: tripdata.visa,
    wa_group:
      "booking" in tripdata && "wa_group" in tripdata.booking
        ? tripdata.booking.wa_group
        : "",
    driver_number: tripdata.driver_number,
    check_in: tripdata.check_in,
    vacation_list: tripdata.vacation_list,
    help_doc: tripdata.help_doc,
    flight_status: tripdata.flight_status,
    briefing_call:
      "booking" in tripdata && "briefing_call" in tripdata.booking
        ? tripdata.booking.briefing_call
        : "",
    book_flight:
      "booking" in tripdata && "flight" in tripdata.booking
        ? tripdata.booking.flight
        : "",
    book_hotel:
      "booking" in tripdata && "hotel" in tripdata.booking
        ? tripdata.booking.hotel
        : "",
    book_land:
      "booking" in tripdata && "land" in tripdata.booking
        ? tripdata.booking.land
        : "",
    book_visa:
      "booking" in tripdata && "visa" in tripdata.booking
        ? tripdata.booking.visa
        : "",
    book_insurance:
      "booking" in tripdata && "insurance" in tripdata.booking
        ? tripdata.booking.insurance
        : "",
    book_add:
      "booking" in tripdata && "others" in tripdata.booking
        ? tripdata.booking.others
        : "",
    advance_booking:
      "advance_booking" in tripdata ? tripdata.advance_booking : false,
    hotel_booking_date:
      "hotel_booking_date" in tripdata ? tripdata.hotel_booking_date : false,
    vm:
      "booking" in tripdata && "voucher_matched" in tripdata.booking
        ? tripdata.booking.voucher_matched
        : "",
    ve:
      "booking" in tripdata && "voucher_explained" in tripdata.booking
        ? tripdata.booking.voucher_explained
        : "",
    bc:
      "booking" in tripdata && "briefing_call" in tripdata.booking
        ? tripdata.booking.briefing_call
        : "",
    inv:
      "booking" in tripdata && "invoice_name_matched" in tripdata.booking
        ? tripdata.booking.invoice_name_matched
        : "",
    refund:
      "booking" in tripdata && "refund_due" in tripdata.booking
        ? tripdata.booking.refund_due
        : "",
    conv_date:
      "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    risk: "cust_payments" in tripdata ? geturgent(tripdata) : "",
    next_date:
      "cust_payments" in tripdata
        ? getnextpaymentdate(tripdata.cust_payments)
        : "",
    profit: "cust_payments" in tripdata ? getprofit(tripdata) : "",
  }));

  const vmcheck = (tripdata) => {
    if ("booking" in tripdata && "voucher_matched" in tripdata.booking) {
      const task = tasklist.filter(
        (t) =>
          t.trip_id == tripdata.trip_id &&
          "assigned_to" in t &&
          t.assigned_to !== "Pawan",
      );
      if (task.length > 0) {
        return tripdata.booking.voucher_matched + " " + task[0].task_id;
      } else {
        return tripdata.booking.voucher_matched;
      }
    } else {
      return "";
    }
  };

  if (leadfilterData.future_trips) {
    if (leadfilterData.future_trips == "Without JC") {
      l22 = l22.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted") &&
          tripdata.hold_ops !== true,
      );
    } else {
      l22 = l22.filter(
        (tripdata) =>
          tripdata.on_hold !== true &&
          "booking" in tripdata &&
          "transfer_state" in tripdata.booking &&
          (tripdata.booking.transfer_state == "Requested" ||
            tripdata.booking.transfer_state == "Accepted" ||
            tripdata.booking.transfer_state == "Just Converted") &&
          tripdata.hold_ops !== true,
      );
    }
  }

  const tripdatalistdisplay3 = l22.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l2.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    book_hotel:
      "booking" in tripdata && "hotel" in tripdata.booking
        ? tripdata.booking.hotel
        : "",
    book_land:
      "booking" in tripdata && "land" in tripdata.booking
        ? tripdata.booking.land
        : "",
    double_check: getallgood(tripdata),
    vm: vmcheck(tripdata),
    ve:
      "booking" in tripdata && "voucher_explained" in tripdata.booking
        ? tripdata.booking.voucher_explained
        : "",
    pm:
      "booking" in tripdata && "preventive_messages" in tripdata.booking
        ? tripdata.booking.preventive_messages
        : "",
    bc:
      "booking" in tripdata && "briefing_call" in tripdata.booking
        ? tripdata.booking.briefing_call
        : "",
    driver: "driver_number" in tripdata ? tripdata.driver_number : "",
    inv:
      "booking" in tripdata && "invoice_name_matched" in tripdata.booking
        ? tripdata.booking.invoice_name_matched
        : "",
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    total: total(tripdata.cust_payments),
    pending: pending(tripdata.cust_payments),
    received: total(tripdata.cust_payments) - pending(tripdata.cust_payments),
    supplier_pending: supplierpending(tripdata.supplier_payments),
    vm_date:
      "booking" in tripdata && "voucher_matched_date" in tripdata.booking
        ? tripdata.booking.voucher_matched_date
        : "",
  }));

  //Kaushal payment view
  var l3 = [];
  var installment = [];
  if (value == 3 || (mainTab == 1 && subTab == 1)) {
    for (var i = 0; i < listtripData.length; i++) {
      if (listtripData[i].cust_payments.length > 0) {
        for (var j = 0; j < listtripData[i].cust_payments.length; j++) {
          if (
            listtripData[i].cust_payments[j].status == "Pending" &&
            new Date(listtripData[i].cust_payments[j].date).getTime() <
              new Date(onedays).getTime()
          ) {
            l3 = [...l3, listtripData[i]];
            installment = [...installment, listtripData[i].cust_payments[j]];
          }
        }
      }
    }
    if (leadfilterData2.ops_owner) {
      l3 = l3.filter(
        (trip) =>
          "booking" in trip &&
          "ops_assigned" in trip.booking &&
          trip.booking.ops_assigned == leadfilterData2.ops_owner,
      );
    }
  }
  const tripdatalistdisplay4 = l3.map((tripdata) => ({
    cust_name: tripdata.cust_name,
    id: l3.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    total: total(tripdata.cust_payments),
    pending: pending(tripdata.cust_payments),
    received: total(tripdata.cust_payments) - pending(tripdata.cust_payments),
    flight: tripdata.flight_sp,
    tl: tripdata.team_leader,
    sales: tripdata.trip_owner,
    installment_date: installment[l3.indexOf(tripdata)].date,
    installment_amount: installment[l3.indexOf(tripdata)].amount,
  }));

  var l4 = [];
  if (value == 4 || (mainTab == 1 && subTab == 2)) {
    for (var i = 0; i < listtripData.length; i++) {
      if (listtripData[i].cust_payments.length > 0) {
        if (
          "booking" in listtripData[i] &&
          "transfer_state" in listtripData[i].booking &&
          listtripData[i].booking.transfer_state !== "Back to Sales" &&
          !("hold_ops" in listtripData[i] && listtripData[i].hold_ops)
        ) {
          if (
            getprofit(listtripData[i]) -
              (total(listtripData[i].cust_payments) -
                pending(listtripData[i].cust_payments)) >
            0
          ) {
            l4 = [...l4, listtripData[i]];
          } else {
            if (
              pending(listtripData[i].cust_payments) !== 0 &&
              (total(listtripData[i].cust_payments) -
                pending(listtripData[i].cust_payments) <
                10000 ||
                total(listtripData[i].cust_payments) -
                  pending(listtripData[i].cust_payments) -
                  listtripData[i].flight_sp <
                  10000)
            ) {
              l4 = [...l4, listtripData[i]];
            }
          }
        }
      }
    }
    if ("threedays" in leadfilterData6 && leadfilterData6.threedays) {
      l4 = l4.filter(
        (trip) =>
          new Date(getconvdate(trip)).getTime() <
          new Date(pastthreedays).getTime(),
      );
    }

    if ("tendays" in leadfilterData6 && leadfilterData6.tendays) {
      l4 = l4.filter(
        (trip) =>
          new Date(getconvdate(trip)).getTime() <
          new Date(pasttendays).getTime(),
      );
    }

    if (leadfilterData6.future_trips) {
      if (leadfilterData6.future_trips == "Without JC") {
        l4 = l4.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted") &&
            tripdata.hold_ops !== true,
        );
      } else {
        l4 = l4.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted" ||
              tripdata.booking.transfer_state == "Just Converted") &&
            tripdata.hold_ops !== true,
        );
      }

      //console.log(l4)
    }
  }
  var l5 = [];

  // if(value==5){

  //   for(var i=0;i<listtripData.length;i++) {
  //     if(listtripData[i].accepted_date && new Date(listtripData[i].accepted_date).getTime()>new Date(pastthreedays).getTime()){

  //       l5=[...l5,listtripData[i]]

  //   }
  //   }
  //   if("threedays" in leadfilterData6){
  //   l5=l5.filter(trip=>new Date(getconvdate(trip)).getTime()<new Date(pastthreedays).getTime())
  // }

  // if(leadfilterData6.future_trips){
  //   l5=l5.filter(tripdata => tripdata.on_hold!==true && "booking" in tripdata && "transfer_state" in tripdata.booking && (tripdata.booking.transfer_state=="Requested" ||  tripdata.booking.transfer_state=="Accepted") && tripdata.hold_ops!==true)
  // //console.log(l4)
  // }
  //   //console.log(l4)
  //   }

  if (value == 5 || (mainTab == 0 && subTab == 7)) {
    for (var i = 0; i < listtripData.length; i++) {
      if (
        "supplier_payments" in listtripData[i] &&
        listtripData[i].supplier_payments.length > 0
      ) {
        for (j = 0; j < listtripData[i].supplier_payments.length; j++) {
          if (leadfilterData2.trip_display == "Show All") {
            if (
              getsuppliertype(listtripData[i].supplier_payments[j].name) ==
                "Hotel Portal" ||
              getsuppliertype(listtripData[i].supplier_payments[j].name) ==
                "Hotel"
            ) {
              l5 = [
                ...l5,
                {
                  trip_id: listtripData[i].trip_id,
                  supplier_name: listtripData[i].supplier_payments[j].name,
                  trip_start_date: listtripData[i].trip_start_date,
                  amount: listtripData[i].supplier_payments[j].amount,
                  cust_name: listtripData[i].cust_name,
                  primary_destination:
                    "secondary_destinations" in listtripData[i]
                      ? listtripData[i].primary_destination +
                        "," +
                        listtripData[i].secondary_destinations
                      : listtripData[i].primary_destination,
                  ops_owner:
                    "booking" in listtripData[i]
                      ? listtripData[i].booking.ops_assigned
                      : "",
                  extra:
                    total(listtripData[i].cust_payments) -
                    pending(listtripData[i].cust_payments) -
                    (sptotal(listtripData[i].supplier_payments) -
                      supplierpending(listtripData[i].supplier_payments)),
                },
              ];
            }
          } else {
            if (
              listtripData[i].supplier_payments[j].status == "Pending" &&
              getsuppliertype(listtripData[i].supplier_payments[j].name) ==
                "Hotel Portal"
            ) {
              l5 = [
                ...l5,
                {
                  trip_id: listtripData[i].trip_id,
                  supplier_name: listtripData[i].supplier_payments[j].name,
                  trip_start_date: listtripData[i].trip_start_date,
                  amount: listtripData[i].supplier_payments[j].amount,
                  cust_name: listtripData[i].cust_name,
                  primary_destination:
                    "secondary_destinations" in listtripData[i]
                      ? listtripData[i].primary_destination +
                        "," +
                        listtripData[i].secondary_destinations
                      : listtripData[i].primary_destination,
                  ops_owner:
                    "booking" in listtripData[i]
                      ? listtripData[i].booking.ops_assigned
                      : "",
                  extra:
                    total(listtripData[i].cust_payments) -
                    pending(listtripData[i].cust_payments) -
                    (sptotal(listtripData[i].supplier_payments) -
                      supplierpending(listtripData[i].supplier_payments)),
                },
              ];
            }
          }
        }
      }
    }
  }

  var l5b = [];
  if (mainTab == 0 && subTab == 8) {
    //console.log("here")
    for (let i = 0; i < listtripData.length; i++) {
      if (
        "supplier_payments" in listtripData[i] &&
        listtripData[i].supplier_payments.length > 0
      ) {
        for (j = 0; j < listtripData[i].supplier_payments.length; j++) {
          if (
            getsuppliertype(listtripData[i].supplier_payments[j].name) ==
            "Flight"
          ) {
            l5b = [
              ...l5b,
              {
                trip_id: listtripData[i].trip_id,
                trip_start_date: listtripData[i].trip_start_date,
                amount: listtripData[i].supplier_payments[j].amount,
                cust_name: listtripData[i].cust_name,
                primary_destination:
                  "secondary_destinations" in listtripData[i]
                    ? listtripData[i].primary_destination +
                      "," +
                      listtripData[i].secondary_destinations
                    : listtripData[i].primary_destination,
                ops_owner:
                  "booking" in listtripData[i]
                    ? listtripData[i].booking.ops_assigned
                    : "",
                airlines: listtripData[i].supplier_payments[j].airline_name,
              },
            ];
          }
        }
      }
    }
    console.log(l5b);
  }

  if (value == 6 || (mainTab == 0 && subTab == 2)) {
    getList();
  }

  var l6 = [];
  if (value == 7 || (mainTab == 0 && subTab == 1)) {
    var fourty = DateCalc(40);
    l6 = listtripData.filter(
      (trip) =>
        "booking" in trip &&
        "visa" in trip.booking &&
        (trip.booking.visa == "No" || trip.booking.visa_applied == "No") &&
        new Date(trip.trip_start_date).getTime() < new Date(fourty).getTime(),
    );
    if (leadfilterData2.ops_owner) {
      l6 = l6.filter(
        (trip) =>
          "booking" in trip &&
          "ops_assigned" in trip.booking &&
          trip.booking.ops_assigned == leadfilterData2.ops_owner,
      );
    }
    if (leadfilterData2.future_trips) {
      if (leadfilterData2.future_trips == "Without JC") {
        l6 = l6.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted") &&
            tripdata.hold_ops !== true,
        );
      } else {
        l6 = l6.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted" ||
              tripdata.booking.transfer_state == "Just Converted") &&
            tripdata.hold_ops !== true,
        );
      }

      //console.log(l4)
    }
    l6 = sortByKey(l6, "trip_start_date");
    //l6=listtripData.filter(trip=>trip.visa=="No" && new Date(trip.trip_start_date).getTime()<new Date(thirty).getTime())
  }

  var l7 = [...listtripData];
  l7 = sortByKey(l7, "trip_start_date");
  var l8 = listtripData2.filter(
    (trip) =>
      "booking" in trip &&
      "fup" in trip.booking &&
      trip.booking.fup.length > 0 &&
      new Date(trip.booking.fup[trip.booking.fup.length - 1].date).getTime() <
        new Date().getTime() &&
      !("hold_ops" in trip && trip.hold_ops) &&
      !(
        "booking" in trip &&
        "flight" in trip.booking &&
        trip.booking.flight == "NA" &&
        "hotel" in trip.booking &&
        trip.booking.hotel == "NA" &&
        "land" in trip.booking &&
        trip.booking.land == "NA"
      ),
  );
  if (value == 8 || (mainTab == 1 && subTab == 3)) {
    if (leadfilterData2.transfer_state) {
      l7 = l7.filter(
        (trip) =>
          "booking" in trip &&
          trip.booking.transfer_state == leadfilterData2.transfer_state,
      );
    }
    if (leadfilterData2.on_hold) {
      l7 = l7.filter((trip) => trip.on_hold !== true);
    }
    if (leadfilterData2.ops_owner) {
      l7 = l7.filter(
        (trip) =>
          "booking" in trip &&
          "ops_assigned" in trip.booking &&
          trip.booking.ops_assigned == leadfilterData2.ops_owner,
      );
    }
    if (leadfilterData2.future_trips) {
      if (leadfilterData2.future_trips == "Without JC") {
        l7 = l7.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted") &&
            tripdata.hold_ops !== true,
        );
      } else {
        l7 = l7.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted" ||
              tripdata.booking.transfer_state == "Just Converted") &&
            tripdata.hold_ops !== true,
        );
      }
      //console.log(l4)
    }
  }

  if (leadfilterData3.ops_owner) {
    l8 = l8.filter(
      (trip) =>
        "booking" in trip &&
        "ops_assigned" in trip.booking &&
        trip.booking.ops_assigned == leadfilterData3.ops_owner,
    );
  }

  var l10 = [...listtripData];
  if (value == 10 || (mainTab == 0 && subTab == 3)) {
    l10 = listtripData.filter(
      (trip) =>
        trip.hold_ops &&
        "booking" in trip &&
        "transfer_state" in trip.booking &&
        trip.booking.transfer_state !== "Back to Sales",
    );
  }
  var l11 = [];
  if (value == 11 || (mainTab == 3 && subTab == 0)) {
    l11 = listtripData.filter(
      (trip) =>
        (("booking" in trip &&
          "transfer_state" in trip.booking &&
          trip.booking.transfer_state == "Back to Sales") ||
          trip.on_hold ||
          trip.hold_ops) &&
        new Date(trip.trip_start_date).getTime() < new Date().getTime(),
    );
  }

  var l12 = [...listtripData];
  if (
    value == 12 ||
    value == 15 ||
    (mainTab == 0 && subTab == 5) ||
    (mainTab == 0 && subTab == 6)
  ) {
    l12 = listtripData.filter(
      (trip) =>
        !(
          ("booking" in trip &&
            "transfer_state" in trip.booking &&
            trip.booking.transfer_state == "Back to Sales") ||
          ("on_hold" in trip && trip.on_hold) ||
          ("hold_ops" in trip && trip.hold_ops) ||
          ("booking" in trip &&
            "transfer_state" in trip.booking &&
            trip.booking.transfer_state == "Just Converted")
        ),
    );
    if (leadfilterData2.future_trips) {
      if (leadfilterData2.future_trips == "Without JC") {
        l12 = l12.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted") &&
            tripdata.hold_ops !== true,
        );
      } else {
        l12 = l12.filter(
          (tripdata) =>
            tripdata.on_hold !== true &&
            "booking" in tripdata &&
            "transfer_state" in tripdata.booking &&
            (tripdata.booking.transfer_state == "Requested" ||
              tripdata.booking.transfer_state == "Accepted" ||
              tripdata.booking.transfer_state == "Just Converted") &&
            tripdata.hold_ops !== true,
        );
      }
      //console.log(l4)
    }
    //  console.log(l12)
    l12 = sortByKey(l12, "trip_start_date");
  }

  var l13 = [];
  if (value == 13 || (mainTab == 0 && subTab == 4)) {
    const startDate = new Date(DateCalc(-3)).getTime();
    const endDate = new Date(DateCalc(1)).getTime();
    //     l13 = listtripData.filter(trip => {
    //   let matched = false;

    //   trip.supplier_payments.forEach(tranche => {
    //     if (tranche.status !== "Paid") {
    //       const activityDate = new Date(tranche.cut_off).getTime();

    //       if (activityDate >= startDate && activityDate <= endDate) {
    //         trip.cut_off = new Date(activityDate);
    //         trip.supplier = tranche.name // assign cut_off to trip
    //         matched = true;
    //       }
    //     }
    //   });

    //   return matched;  // filter only the trips that matched
    // });
    listtripData.forEach((trip) => {
      trip.supplier_payments.forEach((tranche) => {
        if (
          !(
            tranche.status == "Paid" ||
            tranche.status == "Paid by internal team"
          )
        ) {
          const activityDate = new Date(tranche.cut_off).getTime();

          if (activityDate >= startDate && activityDate <= endDate) {
            // create a shallow copy so we don't mutate original
            const tripCopy = {
              ...trip,
              cut_off: activityDate,
              supplier: tranche.name,
              supplier_amount: tranche.amount,
            };

            l13.push(tripCopy);
          }
        }
      });
    });
  }

  var l14 = [];
  if (value == 14 || (mainTab == 1 && subTab == 4)) {
    l14 = listtripData.filter(
      (trip) =>
        !(
          ("booking" in trip &&
            "transfer_state" in trip.booking &&
            trip.booking.transfer_state == "Back to Sales") ||
          trip.on_hold ||
          trip.hold_ops
        ),
    );
    l14 = l14.filter(
      (trip) =>
        "duration" in trip &&
        "trip_start_date" in trip &&
        new Date().getTime() <
          new Date(DateCalc2(trip.trip_start_date, trip.duration)).getTime() &&
        new Date().getTime() > new Date(trip.trip_start_date).getTime(),
    );
  }

  const tripdatalistdisplay5 = l4.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l4.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    total: total(tripdata.cust_payments),
    pending: pending(tripdata.cust_payments),
    received: total(tripdata.cust_payments) - pending(tripdata.cust_payments),
    profit: getprofit(tripdata),
    flight: tripdata.flight_sp,
    next_payment_date:
      "cust_payments" in tripdata
        ? getnextpaymentdate(tripdata.cust_payments)
        : "",
    installment_amount:
      "cust_payments" in tripdata
        ? getnextpaymentamount(tripdata.cust_payments)
        : "",
    flight_ticket:
      "file" in tripdata &&
      tripdata.file.length > 0 &&
      tripdata.file.filter((f) => f.type_of_doc == "Flight Ticket").length > 0
        ? "Done"
        : "Not Done",
    sales: tripdata.trip_owner,
    conv_date: getconvdate(tripdata),
    risk_comment_1: getcomment(tripdata, "At Risk", 1),
    risk_comment_2: getcomment(tripdata, "At Risk", 2),
    risk_comment_3: getcomment(tripdata, "At Risk", 3),
  }));

  const tripdatalistdisplay6 = l5.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l5.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination: tripdata.primary_destination,
    ops_owner: tripdata.ops_owner,
    amount: tripdata.amount,
    extra: tripdata.extra,
    supplier_name: tripdata.supplier_name,
  }));

  const tripdatalistdisplay6b = l5b.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l5b.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination: tripdata.primary_destination,
    ops_owner: tripdata.ops_owner,
    amount: tripdata.amount,
    airlines: tripdata.airlines,
  }));

  const tripdatalistdisplay7 = l8.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l8.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    sales: tripdata.trip_owner,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    status: "Pending",
    pending_on: "",
    // notes:"booking"in tripdata?tripdata.booking.notes:"",
    notes2:
      "booking" in tripdata &&
      "fup" in tripdata.booking &&
      tripdata.booking.fup.length > 0
        ? tripdata.booking.fup[tripdata.booking.fup.length - 1].note
        : "",
  }));

  const tripdatalistdisplay8 = l6.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l6.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    upsell_ops_owner:
      "booking" in tripdata && "upsell_ops_assigned" in tripdata.booking
        ? tripdata.booking.upsell_ops_assigned
        : "",
    book_flight:
      "booking" in tripdata && "flight" in tripdata.booking
        ? tripdata.booking.flight
        : "",
    book_hotel:
      "booking" in tripdata && "hotel" in tripdata.booking
        ? tripdata.booking.hotel
        : "",
    book_land:
      "booking" in tripdata && "land" in tripdata.booking
        ? tripdata.booking.land
        : "",
    apply_visa:
      "booking" in tripdata && "visa_applied" in tripdata.booking
        ? tripdata.booking.visa_applied
        : "",
    apply_date:
      "booking" in tripdata && "visa_applied_date" in tripdata.booking
        ? tripdata.booking.visa_applied_date
        : "",
    book_visa:
      "booking" in tripdata && "visa" in tripdata.booking
        ? tripdata.booking.visa
        : "",
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    flight: tripdata.flight_sp,
    sales: tripdata.trip_owner,
    supplier: getvisasupplier(tripdata),
    visa_comment_1: getcomment(tripdata, "Visa", 1),
    visa_comment_2: getcomment(tripdata, "Visa", 2),
  }));

  const tripdatalistdisplay9 = l7.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l7.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    passport: "booking" in tripdata ? tripdata.booking.passport : "",
    pan: "booking" in tripdata ? tripdata.booking.pan : "",
    aadhaar: "booking" in tripdata ? tripdata.booking.aadhaar : "",
    return_tickets:
      "booking" in tripdata ? tripdata.booking.return_tickets : "",
    pc: "booking" in tripdata ? tripdata.booking.passport_checked : "",
    pm:
      "booking" in tripdata && "preventive_messages" in tripdata.booking
        ? tripdata.booking.preventive_messages
        : "",
    ops_status: "booking" in tripdata ? tripdata.booking.transfer_state : "",
    on_hold: tripdata.on_hold,
    double_check: getallgood(tripdata),
    profit: getprofit(tripdata),
    pna: "supplier_payments" in tripdata ? getpna(tripdata) : false,
    docs_comment_1: getcomment(tripdata, "Docs", 1),
    docs_comment_2: getcomment(tripdata, "Docs", 2),
  }));

  const tripdatalistdisplay10 = l10.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l10.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    book_flight:
      "booking" in tripdata && "flight" in tripdata.booking
        ? tripdata.booking.flight
        : "",
    book_hotel:
      "booking" in tripdata && "hotel" in tripdata.booking
        ? tripdata.booking.hotel
        : "",
    book_land:
      "booking" in tripdata && "land" in tripdata.booking
        ? tripdata.booking.land
        : "",
    book_visa:
      "booking" in tripdata && "visa" in tripdata.booking
        ? tripdata.booking.visa
        : "",
    flight: tripdata.flight_sp,
    profit: "cust_payments" in tripdata ? getprofit(tripdata) : 0,
    pending: "cust_payments" in tripdata ? pending(tripdata.cust_payments) : 0,
    sales: tripdata.trip_owner,
    hold_ops_date: "hold_ops_date" in tripdata ? tripdata.hold_ops_date : "",
    whatsapp:
      "booking" in tripdata && "wa_group" in tripdata.booking
        ? tripdata.booking.wa_group
        : "",
    conv_date: tripdata.converted_date,
    hold_ops_reason:
      "hold_ops_array" in tripdata && tripdata.hold_ops_array.length > 0
        ? tripdata.hold_ops_array[tripdata.hold_ops_array.length - 1].ho_reason
        : "",
  }));

  var tripdatalistdisplay11 = l11.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l11.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    transfer_state:
      "booking" in tripdata && "transfer_state" in tripdata.booking
        ? tripdata.booking.transfer_state
        : "",
    sales: tripdata.trip_owner,
    pending: pending(tripdata.cust_payments),
    hold_ops_date: "hold_ops_date" in tripdata ? tripdata.hold_ops_date : "",
    whatsapp:
      "booking" in tripdata && "wa_group" in tripdata.booking
        ? tripdata.booking.wa_group
        : "",
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    b2s_comment_1: getcomment(tripdata, "B2S", 1),
    b2s_comment_2: getcomment(tripdata, "B2S", 2),
  }));

  const tripdatalistdisplay12 = l12.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l12.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    upsell_ops_owner:
      "booking" in tripdata && "upsell_ops_assigned" in tripdata.booking
        ? tripdata.booking.upsell_ops_assigned
        : "",
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    upsell_comment_1: getcomment(tripdata, "Upsell", 1),
    upsell_comment_2: getcomment(tripdata, "Upsell", 2),
  }));

  const tripdatalistdisplay13 = l13.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l13.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    cut_off: new Date(tripdata.cut_off),
    supplier: tripdata.supplier,
    amount: tripdata.supplier_amount,
  }));

  const tripdatalistdisplay14 = l14.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l14.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    trip_end_date:
      "duration" in tripdata && "trip_start_date" in tripdata
        ? DateCalc2(tripdata.trip_start_date, tripdata.duration)
        : "",
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    og_comment_1: getcomment(tripdata, "OG", 1),
    og_comment_2: getcomment(tripdata, "OG", 2),
  }));

  var tripdatalistdisplay15 = l12.map((tripdata) => ({
    cust_name: getstate(tripdata) + tripdata.cust_name,
    id: l12.indexOf(tripdata),
    trip_id: tripdata.trip_id,
    trip_start_date: tripdata.trip_start_date,
    primary_destination:
      "secondary_destinations" in tripdata
        ? tripdata.primary_destination + "," + tripdata.secondary_destinations
        : tripdata.primary_destination,
    ops_owner: "booking" in tripdata ? tripdata.booking.ops_assigned : "",
    pax:
      "number_child" in tripdata
        ? tripdata.number_adults + tripdata.number_child
        : tripdata.number_adults,
    conv_date: showtrips
      ? "status_history" in tripdata && tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : ""
      : "status_history" in tripdata &&
          Array.isArray(tripdata.status_history) &&
          tripdata.status_history.length > 0
        ? tripdata.status_history[tripdata.status_history.length - 1].date
        : "",
    ops_comment_1: getcomment(tripdata, "Ops", 1),
    ops_comment_2: getcomment(tripdata, "Ops", 2),
    hbd: tripdata.hotel_booking_date,
    lbd: tripdata.land_booking_date,
  }));
  // console.log(tripdatalistfromdb);

  const fetchtasksbydate = async () => {
    try {
      const past30days = DateCalc(-30);
      const tomorrow = DateCalc(1);
      var data = [];
      if (searchData8.start_date && searchData8.end_date) {
        data = await fetchTaskbycreateddate(
          searchData8.start_date,
          searchData8.end_date,
        );
      } else {
        data = await fetchTaskbycreateddate(past30days, tomorrow);
      }
      setalltasklist(data.data);
      const temp = data.data.filter(
        (t) =>
          t.task_status !== "Close" && !("private_task" in t && t.private_task),
      );
      //console.log(temp)
      settasklist(temp);

      if (temp.length > 0) {
        var openops = 0,
          opencs = 0,
          opensales = 0,
          openacc = 0,
          openadm = 0,
          taskdoneops = 0,
          taskdonecs = 0,
          taskdonesales = 0,
          taskdoneadm = 0,
          taskdoneacc = 0,
          inprogressops = 0,
          inprogresscs = 0,
          inprogresssales = 0,
          inprogressacc = 0,
          inprogressadm = 0,
          waitingops = 0,
          waitingcs = 0,
          waitingsales = 0,
          waitingadm = 0,
          waitingacc = 0,
          b2oops = 0,
          b2ocs = 0,
          b2osales = 0,
          b2oacc = 0,
          b2oadm = 0;

        openops = temp.filter(
          (t) =>
            t.task_status == "Open" &&
            (getTeam(t.assigned_to) == "Operations" ||
              getTeam(t.assigned_to) == "Operations-TL"),
        );
        opencs = temp.filter(
          (t) => t.task_status == "Open" && getTeam(t.assigned_to) == "Support",
        );
        openacc = temp.filter(
          (t) =>
            t.task_status == "Open" && getTeam(t.assigned_to) == "Accounts",
        );
        openadm = temp.filter(
          (t) => t.task_status == "Open" && getTeam(t.assigned_to) == "HR",
        );
        opensales = temp.filter(
          (t) =>
            t.task_status == "Open" &&
            (getTeam(t.assigned_to) == "TL" ||
              getTeam(t.assigned_to) == "Manager"),
        );
        taskdoneops = temp.filter(
          (t) =>
            t.task_status == "Task Done" &&
            (getTeam(t.assigned_to) == "Operations" ||
              getTeam(t.assigned_to) == "Operations-TL"),
        );
        taskdonecs = temp.filter(
          (t) =>
            t.task_status == "Task Done" && getTeam(t.assigned_to) == "Support",
        );
        taskdoneacc = temp.filter(
          (t) =>
            t.task_status == "Task Done" &&
            getTeam(t.assigned_to) == "Accounts",
        );
        taskdoneadm = temp.filter(
          (t) => t.task_status == "Task Done" && getTeam(t.assigned_to) == "HR",
        );
        taskdonesales = temp.filter(
          (t) =>
            t.task_status == "Task Done" &&
            (getTeam(t.assigned_to) == "TL" ||
              getTeam(t.assigned_to) == "Manager"),
        );
        inprogressops = temp.filter(
          (t) =>
            t.task_status == "In Progress" &&
            (getTeam(t.assigned_to) == "Operations" ||
              getTeam(t.assigned_to) == "Operations-TL"),
        );
        inprogresscs = temp.filter(
          (t) =>
            t.task_status == "In Progress" &&
            getTeam(t.assigned_to) == "Support",
        );
        inprogressacc = temp.filter(
          (t) =>
            t.task_status == "In Progress" &&
            getTeam(t.assigned_to) == "Accounts",
        );
        inprogressadm = temp.filter(
          (t) =>
            t.task_status == "In Progress" && getTeam(t.assigned_to) == "HR",
        );
        inprogresssales = temp.filter(
          (t) =>
            t.task_status == "In Progress" &&
            (getTeam(t.assigned_to) == "TL" ||
              getTeam(t.assigned_to) == "Manager"),
        );
        waitingops = temp.filter(
          (t) =>
            t.task_status == "Waiting" &&
            (getTeam(t.assigned_to) == "Operations" ||
              getTeam(t.assigned_to) == "Operations-TL"),
        );
        waitingcs = temp.filter(
          (t) =>
            t.task_status == "Waiting" && getTeam(t.assigned_to) == "Support",
        );
        waitingacc = temp.filter(
          (t) =>
            t.task_status == "Waiting" && getTeam(t.assigned_to) == "Accounts",
        );
        waitingadm = temp.filter(
          (t) => t.task_status == "Waiting" && getTeam(t.assigned_to) == "HR",
        );
        waitingsales = temp.filter(
          (t) =>
            t.task_status == "Waiting" &&
            (getTeam(t.assigned_to) == "TL" ||
              getTeam(t.assigned_to) == "Manager"),
        );
        b2oops = temp.filter(
          (t) =>
            t.task_status == "Back to Owner" &&
            (getTeam(t.assigned_to) == "Operations" ||
              getTeam(t.assigned_to) == "Operations-TL"),
        );
        b2ocs = temp.filter(
          (t) =>
            t.task_status == "Back to Owner" &&
            getTeam(t.assigned_to) == "Support",
        );
        b2oacc = temp.filter(
          (t) =>
            t.task_status == "Back to Owner" &&
            getTeam(t.assigned_to) == "Accounts",
        );
        b2oadm = temp.filter(
          (t) =>
            t.task_status == "Back to Owner" && getTeam(t.assigned_to) == "HR",
        );
        b2osales = temp.filter(
          (t) =>
            t.task_status == "Back to Owner" &&
            (getTeam(t.assigned_to) == "TL" ||
              getTeam(t.assigned_to) == "Manager"),
        );

        const finalarr = [
          {
            team: "Support",
            open: opencs.length,
            inprogress: inprogresscs.length,
            waiting: waitingcs.length,
            taskdone: taskdonecs.length,
            b2o: b2ocs.length,
            total:
              opencs.length +
              inprogresscs.length +
              waitingcs.length +
              taskdonecs.length +
              b2ocs.length,
          },
          {
            team: "Operations",
            open: openops.length,
            inprogress: inprogressops.length,
            waiting: waitingops.length,
            taskdone: taskdoneops.length,
            b2o: b2oops.length,
            total:
              openops.length +
              inprogressops.length +
              waitingops.length +
              taskdoneops.length +
              b2oops.length,
          },
          {
            team: "Sales",
            open: opensales.length,
            inprogress: inprogresssales.length,
            waiting: waitingsales.length,
            taskdone: taskdonesales.length,
            b2o: b2osales.length,
            total:
              opensales.length +
              inprogresssales.length +
              waitingsales.length +
              taskdonesales.length +
              b2osales.length,
          },
          {
            team: "Accounts",
            open: openacc.length,
            inprogress: inprogressacc.length,
            waiting: waitingacc.length,
            taskdone: taskdoneacc.length,
            b2o: b2oacc.length,
            total:
              openacc.length +
              inprogressacc.length +
              waitingacc.length +
              taskdoneacc.length +
              b2oacc.length,
          },
          {
            team: "Admin",
            open: openadm.length,
            inprogress: inprogressadm.length,
            waiting: waitingadm.length,
            taskdone: taskdoneadm.length,
            b2o: b2oadm.length,
            total:
              openadm.length +
              inprogressadm.length +
              waitingadm.length +
              taskdoneadm.length +
              b2oadm.length,
          },
        ];
        console.log(finalarr);
        settasklist2(finalarr);
      }
    } catch (err) {
      console.log(err);
    }
  };

  var l100 = [...tasklist];
  if (showalltasks) {
    l100 = [...alltasklist];
  }
  if (leadfilterData5.status) {
    if (leadfilterData5.status == "Without Task Done") {
      l100 = l100.filter((t) => t.task_status !== "Task Done");
    } else {
      l100 = l100.filter((t) => t.task_status == leadfilterData5.status);
    }
  }

  if (leadfilterData5.assigned_to) {
    if (leadfilterData5.assigned_to == "Sales") {
      l100 = l100.filter(
        (t) =>
          getTeam(t.assigned_to) == "TL" || getTeam(t.assigned_to) == "Manager",
      );
    } else if (leadfilterData5.assigned_to == "Operations") {
      l100 = l100.filter(
        (t) =>
          getTeam(t.assigned_to) == "Operations" ||
          getTeam(t.assigned_to) == "Operations-TL",
      );
    } else {
      l100 = l100.filter(
        (t) => getTeam(t.assigned_to) == leadfilterData5.assigned_to,
      );
    }
  }

  if (leadfilterData5.days_elapsed) {
    if (leadfilterData5.days_elapsed == "0-1") {
      l100 = l100.filter(
        (t) =>
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) <
          1,
      );
    } else if (leadfilterData5.days_elapsed == "1-2") {
      l100 = l100.filter(
        (t) =>
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) >=
            1 &&
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) <
            2,
      );
    } else if (leadfilterData5.days_elapsed == "2-3") {
      l100 = l100.filter(
        (t) =>
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) >=
            2 &&
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) <
            3,
      );
    } else if (leadfilterData5.days_elapsed == "3-7") {
      l100 = l100.filter(
        (t) =>
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) >=
            3 &&
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) <
            7,
      );
    } else if (leadfilterData5.days_elapsed == "7+") {
      l100 = l100.filter(
        (t) =>
          (new Date().getTime() - new Date(t.createdAt).getTime()) /
            (1000 * 60 * 60 * 24) >=
          7,
      );
    }
  }

  const taskdatalistdisplay = l100.map((t) => ({
    id: l100.indexOf(t),
    task_id: t.task_id,
    trip_id: t.trip_id,
    assigned_to: t.assigned_to,
    assigned_by: t.assigned_by,
    task_status: t.task_status,
    task_priority: t.task_priority,
    task_category: t.task_category,
    wrong_ticket:t.wrong_ticket,
    time_elapsed: (
      (new Date().getTime() - new Date(t.createdAt).getTime()) /
      (1000 * 60 * 60)
    ).toFixed(2),
    days_elapsed: parseInt(
      (
        (new Date().getTime() - new Date(t.createdAt).getTime()) /
        (1000 * 60 * 60 * 24)
      ).toFixed(1),
    ),
    createdAt: t.createdAt,
    task_deadline: getISOstring(t.deadline_date, t.deadline_time),
    assignedby_team: getTeam(t.assigned_by),
    assignedto_team: getTeam(t.assigned_to),
  }));

  const taskdatalistdisplay2 = tasklist2.map((t) => ({
    id: tasklist2.indexOf(t),
    team: t.team,
    open: t.open,
    inprogress: t.inprogress,
    waiting: t.waiting,
    taskdone: t.taskdone,
    b2o: t.b2o,
    total: t.total,
  }));

  const getticketmetrics = (arr) => {
    var ret = {};
    if (arr.length > 0) {
      var closedcount = 0,
        tdcount = 0,
        closedtimediff = 0,
        tdtimediff = 0;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].task_status == "Close") {
          closedcount++;
          for (let j = 0; j < arr[i].status_history.length; j++) {
            if (arr[i].status_history[j].status == "Close") {
              closedtimediff =
                closedtimediff +
                (new Date(arr[i].status_history[j].status_date).getTime() -
                  new Date(arr[i].createdAt));
            }
            if (arr[i].status_history[j].status == "Task Done") {
              tdtimediff =
                tdtimediff +
                (new Date(arr[i].status_history[j].status_date).getTime() -
                  new Date(arr[i].createdAt));
            }
          }
        } else if (arr[i].task_status == "Task Done") {
          tdcount++;
          for (let j = 0; j < arr[i].status_history.length; j++) {
            if (arr[i].status_history[j].status == "Task Done") {
              tdtimediff =
                tdtimediff +
                (new Date(arr[i].status_history[j].status_date).getTime() -
                  new Date(arr[i].createdAt));
            }
          }
        } else {
        }
      }
      ret = {
        closedcount: closedcount,
        closedtimediff: closedtimediff,
        tdtimediff: tdtimediff,
        tdcount: tdcount,
      };
    } else {
      ret = {
        closedcount: 0,
        closedtimediff: 0,
        tdtimediff: 0,
        tdcount: 0,
      };
    }
    return ret;
  };
  var taskfinarr = [];
  var l200 = [...alltasklist];

  if (l200.length > 0) {
    if (leadfilterData5.priority) {
      l200 = l200.filter((t) => t.task_priority == leadfilterData5.priority);
    }
    if (leadfilterData5.tl) {
      l200 = l200.filter((t) => t.assigned_to == leadfilterData5.tl);
    }
    var opsticket = l200.filter(
      (t) =>
        getTeam(t.assigned_to) == "Operations" ||
        getTeam(t.assigned_to) == "Operations-TL",
    );
    var x = getticketmetrics(opsticket);
    var temp = {
      name: "Operations",
      count: opsticket.length,
      closed: x.closedcount,
      avg_close_time: (
        x.closedtimediff /
        (x.closedcount * 1000 * 60 * 60)
      ).toFixed(1),
      avg_resolution_time: (
        x.tdtimediff /
        ((x.closedcount + x.tdcount) * 1000 * 60 * 60)
      ).toFixed(1),
    };
    taskfinarr = [...taskfinarr, temp];
    var cxticket = l200.filter((t) => getTeam(t.assigned_to) == "Support");
    var y = getticketmetrics(cxticket);
    var temp2 = {
      name: "Support",
      count: cxticket.length,
      closed: y.closedcount,
      avg_close_time: (
        y.closedtimediff /
        (y.closedcount * 1000 * 60 * 60)
      ).toFixed(1),
      avg_resolution_time: (
        y.tdtimediff /
        ((y.closedcount + x.tdcount) * 1000 * 60 * 60)
      ).toFixed(1),
    };
    taskfinarr = [...taskfinarr, temp2];
    var salesticket = l200.filter(
      (t) =>
        getTeam(t.assigned_to) == "TL" || getTeam(t.assigned_to) == "Manager",
    );
    var z = getticketmetrics(salesticket);
    var temp3 = {
      name: "Sales",
      count: salesticket.length,
      closed: z.closedcount,
      avg_close_time: (
        z.closedtimediff /
        (z.closedcount * 1000 * 60 * 60)
      ).toFixed(1),
      avg_resolution_time: (
        z.tdtimediff /
        ((z.closedcount + z.tdcount) * 1000 * 60 * 60)
      ).toFixed(1),
    };
    taskfinarr = [...taskfinarr, temp3];
    var opsticket22 = l200.filter(
      (t) =>
        getTeam(t.assigned_to) == "Operations" ||
        getTeam(t.assigned_to) == "Operations-TL",
    );
    var opsticket33 = opsticket22.filter((t) => t.task_category !== "Refund");
    var xy = getticketmetrics(opsticket33);
    var temp44 = {
      name: "Operations-NR",
      count: opsticket33.length,
      closed: xy.closedcount,
      avg_close_time: (
        xy.closedtimediff /
        (xy.closedcount * 1000 * 60 * 60)
      ).toFixed(1),
      avg_resolution_time: (
        xy.tdtimediff /
        ((xy.closedcount + xy.tdcount) * 1000 * 60 * 60)
      ).toFixed(1),
    };
    taskfinarr = [...taskfinarr, temp44];
  }

  const taskdatalistdisplay3 = taskfinarr.map((t) => ({
    id: taskfinarr.indexOf(t),
    name: t.name,
    closed: t.closed,
    count: t.count,
    avg_close_time: t.avg_close_time,
    avg_resolution_time: t.avg_resolution_time,
  }));

  //console.log(l14)
  //console.log(tripdatalistdisplay14)

  const handleChange = async (event, newValue) => {
    setValue(newValue);
    if (newValue == 9) {
      fetchtasksbydate();
    }
  };

  const gridcellclick = (id) => {
    window.open("/tripdataentry/" + id, "_blank");
    //console.log("/custdataentry/"+id);
  };

  const gridcellclickpayment = (id) => {
    window.open("/tripdataentry/" + id + "/paymentupdate", "_blank");
    //console.log("/custdataentry/"+id);
  };

  const gridcellclicktask = (id) => {
    window.open("/taskdataentry/" + id, "_blank");
    //console.log("/custdataentry/"+id);
  };

  const onRowDoubleClick = (rowData) => {
    window.open("/tripdataentry/" + rowData.trip_id, "_blank");
  };

  const rowClassName = (rowData) => {
    return {
      color: rowData.red_flag ? "red" : "black",
    };
  };

  const updatecomment2 = async () => {
    const tripid = l6[selection[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Visa",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
    }
  };

  const updatecomment3 = async () => {
    const tripid = l7[selection2[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Docs",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
    }
  };

  const updatecomment4 = async () => {
    var temparr = [...listtripData];
    const tripid = tripdatalistdisplay11[selection11[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date().toISOString(),
      status: "B2S",
    };
    if (comment) {
      // var tripd=tripdatalistdisplay11.filter(t=>t.trip_id==tripid)
      // var comment2=tripd[0].b2s_comment_1
      temparr = temparr.map((trip) =>
        trip.trip_id == tripid
          ? { ...trip, tl_comment: [...trip.tl_comment, temp] }
          : trip,
      );
      //console.log(temparr)

      const data = await fetchTripbyId(tripid);
      const data2 = await updateTripdata(data.data._id, {
        ...data.data,
        tl_comment: [...data.data.tl_comment, temp],
      });
      if (data2.status == 200) {
        alert("Comment updated");
        setlisttripData(temparr);
      }
    }
  };
  //console.log(listtripData)

  const updatecomment5 = async () => {
    const tripid = l12[selection12[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Upsell",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
    }
  };

  const updatecomment6 = async () => {
    const tripid = l4[selection4[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "At Risk",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
    }
  };

  const updatecomment7 = async () => {
    const tripid = l14[selection14[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "OG",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
    }
  };

  const updatecomment8 = async () => {
    const tripid = l12[selection15[0]].trip_id;
    var comment = prompt("Enter new comment:");
    var temp = {
      comment: comment,
      comment_date: new Date(),
      status: "Ops",
    };
    const data = await fetchTripbyId(tripid);
    const data2 = await updateTripdata(data.data._id, {
      ...data.data,
      tl_comment: [...data.data.tl_comment, temp],
    });
    if (data2.status == 200) {
      alert("Comment updated");
      // var temparr=listtripData.map(t=>t.trip_id==tripid?{...t, tl_comment:[...t.tl_comment,temp]}:t)
      // console.log(temparr)
      // //setlisttripData(temparr)
      // tripdatalistdisplay15=tripdatalistdisplay15.map(t=>t.trip_id==tripid?
      //   {...t, ops_comment_1:comment, ops_comment_2:getcomment(t, "Ops", 1),}:t)
      //setrefresh(refresh+1)
    }
  };
  //console.log(l12)
  //console.log(refresh)

  const searchtripbytourid = async () => {
    try {
      if (
        "tour_id" in leadfilterData &&
        Number.isInteger(Number(leadfilterData.tour_id))
      ) {
        const data = await fetchConvertedTripsbyTourid(leadfilterData.tour_id);
        const temp = removeDuplicates(data.data, "trip_id");
        setlisttripData(temp);
      } else {
        alert("Please enter correct details and try again");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const searchtripbyhotelid = async () => {
    try {
      if (
        "hotel_id" in leadfilterData &&
        Number.isInteger(Number(leadfilterData.hotel_id))
      ) {
        const data = await fetchConvertedTripsbyHotelid(
          leadfilterData.hotel_id,
        );
        const temp = removeDuplicates(data.data, "trip_id");
        setlisttripData(temp);
      } else {
        alert("Please enter correct details and try again");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const searchtaskbytourid = async () => {
    try {
      if (
        "tour_id" in leadfilterData4 &&
        Number.isInteger(Number(leadfilterData4.tour_id))
      ) {
        const data = await fetchtaskbytripid(leadfilterData4.tour_id);
        //console.log(data.data)
        settasklist(data.data);
      } else {
        alert("Please enter correct details and try again");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const listnotrecohotels = async () => {
    try {
      const data = await notrecohotel();
      alert(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchopssummary = () => {
    var onedayaccepted = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        new Date(t.accepted_date).getTime() <
          new Date(DateCalc(-1)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    var threedayaccepted = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        new Date(t.accepted_date).getTime() <
          new Date(DateCalc(-3)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    var fivedayaccepted = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        new Date(t.accepted_date).getTime() <
          new Date(DateCalc(-5)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    var tendayaccepted = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        new Date(t.accepted_date).getTime() <
          new Date(DateCalc(-10)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    var tendaystart = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        new Date(t.trip_start_date).getTime() >
          new Date(DateCalc(-1)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(11)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    var advance = listtripData.filter(
      (t) =>
        "booking" in t &&
        "accepted_date" in t &&
        t.booking.transfer_state == "Accepted" &&
        t.advance_booking &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(90)).getTime() &&
        !("hold_ops" in t && t.hold_ops),
    );
    //console.log(threedayaccepted.length)
    var hotelpending1 = onedayaccepted.filter((t) => t.booking.hotel == "No");
    var hotelpending101 = hotelpending1.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() <
        new Date(DateCalc(10)).getTime(),
    );
    var hotelpending10to301 = hotelpending1.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(10)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(30)).getTime(),
    );
    var hotelpending30to601 = hotelpending1.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(30)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(60)).getTime(),
    );
    var hotelpending601 = hotelpending1.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
        new Date(DateCalc(60)).getTime(),
    );
    console.log(hotelpending1.map((t) => t.trip_id));

    var hotelpending = threedayaccepted.filter((t) => t.booking.hotel == "No");
    var hotelpending10 = hotelpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() <
        new Date(DateCalc(10)).getTime(),
    );
    var hotelpending10to30 = hotelpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(10)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(30)).getTime(),
    );
    var hotelpending30to60 = hotelpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(30)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(60)).getTime(),
    );
    var hotelpending60 = hotelpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
        new Date(DateCalc(60)).getTime(),
    );
    console.log(hotelpending.map((t) => t.trip_id));

    var landpending = fivedayaccepted.filter((t) => t.booking.land == "No");
    var landpending10 = landpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() <
        new Date(DateCalc(10)).getTime(),
    );
    var landpending10to30 = landpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(10)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(30)).getTime(),
    );
    var landpending30to60 = landpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
          new Date(DateCalc(30)).getTime() &&
        new Date(t.trip_start_date).getTime() <
          new Date(DateCalc(60)).getTime(),
    );
    var landpending60 = landpending.filter(
      (t) =>
        new Date(t.trip_start_date).getTime() >=
        new Date(DateCalc(60)).getTime(),
    );
    console.log(landpending.map((t) => t.trip_id));
    const tenvm = tendaystart.filter(
      (t) =>
        !(
          "booking" in t &&
          "voucher_matched" in t.booking &&
          t.booking.voucher_matched == "Yes"
        ),
    );
    console.log(tenvm.map((t) => t.trip_id));
    const tenbc = tendaystart.filter(
      (t) =>
        !(
          "booking" in t &&
          "briefing_call" in t.booking &&
          t.booking.briefing_call == "Yes"
        ) &&
        new Date(t.accepted_date).getTime() > new Date("2026-08-01").getTime(),
    );
    const tenbcyes = tendayaccepted.filter(
      (t) =>
        !(
          "booking" in t &&
          "briefing_call" in t.booking &&
          t.booking.briefing_call == "Yes"
        ) &&
        new Date(t.accepted_date).getTime() > new Date("2026-08-01").getTime(),
    );
    const bcpending = threedayaccepted.filter(
      (t) =>
        !(
          "booking" in t &&
          "briefing_call" in t.booking &&
          (t.booking.briefing_call == "Yes" ||
            t.booking.briefing_call == "Attempted" ||
            t.booking.briefing_call == "NA")
        ) &&
        new Date(t.trip_start_date).getTime() >
          new Date(DateCalc(2)).getTime() &&
        new Date(t.accepted_date).getTime() > new Date("2026-08-01").getTime(),
    );
    console.log(tenbc.map((t) => t.trip_id));
    console.log(bcpending.map((t) => t.trip_id));
    const tenhp = tendaystart.filter(
      (t) =>
        !(
          "booking" in t &&
          "hotel_pitch" in t.booking &&
          t.booking.hotel_pitch == "Yes"
        ) &&
        new Date(t.accepted_date).getTime() > new Date("2026-08-01").getTime() && !("hold_ops" in t && t.hold_ops)
    );
    const hppending = threedayaccepted.filter(
      (t) =>
        !(
          "booking" in t &&
          "hotel_pitch" in t.booking &&
          (t.booking.hotel_pitch == "Interested" ||
            t.booking.hotel_pitch == "Attempted" ||
            t.booking.hotel_pitch == "NA" ||
            t.booking.hotel_pitch == "Yes" ||
            t.booking.hotel_pitch == "Upsell Done" ||
            t.booking.hotel_pitch == "Non Refundable" ||
            t.booking.hotel_pitch == "Red Flag Guest")
        ) &&
        new Date(t.trip_start_date).getTime() >
          new Date(DateCalc(2)).getTime() &&
        new Date(t.accepted_date).getTime() > new Date("2026-08-01").getTime() && !("hold_ops" in t && t.hold_ops)
    );
    console.log(tenhp.map((t) => t.trip_id));
    console.log(hppending.map((t) => t.trip_id));
    const advancepending = advance.filter(
      (t) =>
        !(
          "booking" in t &&
          "advance_tickets" in t.booking &&
          t.booking.advance_tickets == "Done"
        ),
    );
    console.log(advancepending.map((t) => t.trip_id));

    setsummarydata({
      hotel1: hotelpending1.length,
      hotel: hotelpending.length,
      hotel10: hotelpending10.length,
      hotel10to30: hotelpending10to30.length,
      hotel30to60: hotelpending30to60.length,
      hotel60: hotelpending60.length,
      hotel101: hotelpending101.length,
      hotel10to301: hotelpending10to301.length,
      hotel30to601: hotelpending30to601.length,
      hotel601: hotelpending601.length,
      land: landpending.length,
      land10: landpending10.length,
      land10to30: landpending10to30.length,
      land30to60: landpending30to60.length,
      land60: landpending60.length,
      vm: tenvm.length,
      tenbc: tenbc.length,
      bcyes: tenbcyes.length,
      bc: bcpending.length,
      tenhp: tenhp.length,
      hp: hppending.length,
      advance: advancepending.length,
    });
    setOpen19(true);
  };

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
  const paginatorRight = <Button type="button" icon="pi pi-download" text />;

  const onSort = (e) => {
    if (e.originalEvent.altKey) {
      // Multi-column sort with Alt key
      const existingSortIndex = multiSortMeta?.findIndex(
        (meta) => meta.field === e.sortField,
      );

      let newSortMeta = [...(multiSortMeta || [])];

      if (existingSortIndex >= 0) {
        // Toggle sort order if field is already sorted
        newSortMeta[existingSortIndex].order =
          newSortMeta[existingSortIndex].order === 1 ? -1 : 1;
      } else {
        // Add new field to sort metadata
        newSortMeta.push({ field: e.sortField, order: e.sortOrder });
      }

      setMultiSortMeta(newSortMeta);
    } else {
      // Single-column sort
      setMultiSortMeta([{ field: e.sortField, order: e.sortOrder }]);
    }
  };

  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  if (working) {
    return <Loading message={`Loading data...`} />;
  }

  //console.log(mainTab)
  return (
    <div>
      <Dialog fullWidth maxWidth="xl" open={Open19} onClose={handleClose19}>
        {summarydata ? (
          <Table>
            <TableRow>
              <TableCell>
                Total Hotel Pending (A+1): {summarydata.hotel1}
              </TableCell>
              <TableCell>Less than 10 days: {summarydata.hotel101}</TableCell>
              <TableCell>10 to 30 days: {summarydata.hotel10to301}</TableCell>
              <TableCell>30 to 60 days: {summarydata.hotel30to601}</TableCell>
              <TableCell>More than 60 days: {summarydata.hotel601}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Total Hotel Pending (A+3): {summarydata.hotel}
              </TableCell>
              <TableCell>Less than 10 days: {summarydata.hotel10}</TableCell>
              <TableCell>10 to 30 days: {summarydata.hotel10to30}</TableCell>
              <TableCell>30 to 60 days: {summarydata.hotel30to60}</TableCell>
              <TableCell>More than 60 days: {summarydata.hotel60}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Total Land Pending (A+5): {summarydata.land}
              </TableCell>
              <TableCell>Less than 10 days: {summarydata.land10}</TableCell>
              <TableCell>10 to 30 days: {summarydata.land10to30}</TableCell>
              <TableCell>30 to 60 days: {summarydata.land30to60}</TableCell>
              <TableCell>More than 60 days: {summarydata.land60}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>VM Pending (D-10): {summarydata.vm}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Brieifng Call (A+3): {summarydata.bc}</TableCell>
              <TableCell>
                Brieifng Call Done (A+10): {summarydata.bcyes}
              </TableCell>
              <TableCell>Brieifng Call (D-10): {summarydata.tenbc}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Hotel Pitch (A+3): {summarydata.hp}</TableCell>
              <TableCell>Hotel Pitch (D-10): {summarydata.tenhp}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Advance Booking (D-90): {summarydata.advance}
              </TableCell>
            </TableRow>
          </Table>
        ) : (
          ""
        )}
      </Dialog>
      {cuser && role && emp ? (
        <div align="center">
          <Box sx={{ width: "100%" }}>
            {/* ---------- MAIN TABS ---------- */}
            <div align="center">
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tabs
                  value={mainTab}
                  onChange={handleMainTabChange}
                  aria-label="main tabs"
                  centered
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Ops" {...a11yProps(0)} />
                  <Tab label="CX" {...a11yProps(1)} />
                  <Tab label="All" {...a11yProps(2)} />
                  <Tab label="Others" {...a11yProps(3)} />
                </Tabs>
              </Box>
            </div>
            {/* ---------- SUB TABS FOR OPS ---------- */}
            {mainTab === 0 && (
              <>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tabs
                    value={subTab}
                    onChange={handleSubTabChange}
                    aria-label="ops sub tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    centered
                  >
                    <Tab label="Ops Flags" {...a11yProps(0)} />
                    <Tab label="Visa" {...a11yProps(1)} />
                    <Tab label="Daily Task" {...a11yProps(2)} />
                    <Tab label="Hold Operations" {...a11yProps(3)} />
                    <Tab label="Cut Off" {...a11yProps(4)} />
                    <Tab label="Upsell" {...a11yProps(5)} />
                    <Tab label="Ops Profit" {...a11yProps(6)} />
                    <Tab label="Hotel Portal" {...a11yProps(7)} />
                    <Tab label="Airlines" {...a11yProps(8)} />
                  </Tabs>
                </Box>

                <TabPanel value={subTab} index={0}>
                  <Paper variant="outlined" className={classes.paper}>
                    <Typography
                      variant="h4"
                      align="center"
                      className={classes.headertext}
                    >
                      {" "}
                      View Converted Trips
                    </Typography>
                    <p>
                      Advance Booking includes inventories that should be booked
                      in advance or inventories that requires prior go ahead
                    </p>
                    <div align="center">
                      <FormGroup row className={classes.formgroup}>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="trip owner">Trip Owner</InputLabel>
                          <Select
                            displayEmpty
                            className={classes.textField}
                            InputLabelProps={{ shrink: true }}
                            labelId="Trip Owner"
                            value={leadfilterData.trip_owner}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                trip_owner: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Amit"}>Amit</MenuItem>
                            {emp.map((emp) => {
                              return <MenuItem value={emp}>{emp}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="ops owner">Ops Owner</InputLabel>
                          <Select
                            displayEmpty
                            className={classes.textField}
                            InputLabelProps={{ shrink: true }}
                            labelId="Ops Owner"
                            value={leadfilterData.ops_owner}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                ops_owner: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>

                            {emp2.map((emp) => {
                              return <MenuItem value={emp}>{emp}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="TF">Transfer Status</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="TF"
                            value={leadfilterData.transfer_status}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                transfer_status: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Just Converted"}>
                              Just Converted
                            </MenuItem>
                            <MenuItem value={"Requested"}>Requested</MenuItem>
                            <MenuItem value={"Accepted"}>Accepted</MenuItem>
                            <MenuItem value={"Back to Sales"}>
                              Back to Sales
                            </MenuItem>
                            <MenuItem value={"Non B2S"}>Non B2S</MenuItem>
                            <MenuItem value={"NA"}>NA</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="CF">Confirmed Trips</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="CF"
                            value={leadfilterData.future_trips}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                future_trips: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                            <MenuItem value={"Without JC"}>Without JC</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="3D">3 Days</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="3D"
                            value={leadfilterData.threedays}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                threedays: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="3D">Invoice/PAN</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="3D"
                            value={leadfilterData.invoice}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                invoice: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                            <MenuItem value={"7 Days"}>7 Days</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="BC">Briefing Call</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="BC"
                            value={leadfilterData.bc}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                bc: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                            <MenuItem value={"No"}>No</MenuItem>
                            <MenuItem value={"NA"}>NA</MenuItem>
                            <MenuItem value={"Attempted"}>Attempted</MenuItem>
                            <MenuItem value={"Not Attempted"}>
                              Not Attempted
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="HP">Hotel Pitch</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="HP"
                            value={leadfilterData.hp}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                hp: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Yes"}>Yes</MenuItem>
                            <MenuItem value={"No"}>No</MenuItem>
                            <MenuItem value={"NA"}>NA</MenuItem>
                            <MenuItem value={"Attempted"}>Attempted</MenuItem>
                            <MenuItem value={"Not Attempted"}>
                              Not Attempted
                            </MenuItem>
                            <MenuItem value={"Upsell Done"}>
                              Upsell Done
                            </MenuItem>
                            <MenuItem value={"Non Refundable"}>
                              Non Refundable
                            </MenuItem>
                            <MenuItem value={"Red Flag Guest"}>
                              Red Flag Guest
                            </MenuItem>
                            <MenuItem value={"Interested"}>Interested</MenuItem>
                          </Select>
                        </FormControl>
                      </FormGroup>

                      <br></br>
                      <br></br>
                      {role == "Admin" ||
                      role == "Product" ||
                      role == "Operations-TL" ? (
                        <div align="center">
                          <FormGroup row className={classes.formgroup}>
                            <div align="center">
                              <TextField
                                variant="outlined"
                                label="Enter tour id:"
                                InputLabelProps={{ shrink: true }}
                                value={leadfilterData.tour_id}
                                className={classes.textField}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    tour_id: e.target.value,
                                  })
                                }
                              />
                              <Button
                                onClick={() => searchtripbytourid()}
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                              >
                                Fetch
                              </Button>
                            </div>
                            <div align="center">
                              <TextField
                                variant="outlined"
                                label="Enter hotel id:"
                                InputLabelProps={{ shrink: true }}
                                value={leadfilterData.hotel_id}
                                className={classes.textField}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    hotel_id: e.target.value,
                                  })
                                }
                              />
                              <Button
                                onClick={() => searchtripbyhotelid()}
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                              >
                                Fetch
                              </Button>
                              <Button
                                onClick={() => listnotrecohotels()}
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                              >
                                Not Reco
                              </Button>
                              <Button
                                onClick={() => fetchopssummary()}
                                variant="contained"
                                color="primary"
                                className={classes.button}
                              >
                                Ops Summary
                              </Button>
                            </div>
                          </FormGroup>
                        </div>
                      ) : (
                        ""
                      )}
                      {showfilter ? (
                        <div>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Trip Model">
                                Trip Model
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Trip Model"
                                value={leadfilterData.trip_model}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    trip_model: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"B2B"}>B2B</MenuItem>
                                <MenuItem value={"B2C"}>B2C</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="OF">Only Flight</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="OF"
                                value={leadfilterData.only_flight}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    only_flight: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="NoTax">No Tax</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Trip NoTax"
                                value={leadfilterData.no_tax}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    no_tax: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Flight Ticket">
                                Flight Ticket
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Flight Ticket"
                                value={leadfilterData.flight_ticket}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    flight_ticket: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Hotel Voucher">
                                Hotel Voucher
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Hotel Voucher"
                                value={leadfilterData.hotel_voucher}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    hotel_voucher: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Land Voucher">
                                Land Voucher
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Hotel Voucher"
                                value={leadfilterData.land_voucher}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    land_voucher: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Visa">Visa</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Visa"
                                value={leadfilterData.visa}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    visa: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="CheckIn">
                                {" "}
                                Flight CheckIn
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="CheckIn"
                                value={leadfilterData.check_in}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    check_in: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Driver Number">
                                Driver Number
                              </InputLabel>
                              <Select
                                displayEmpty
                                classname={classes.textField}
                                labelId="Driver Number"
                                value={leadfilterData.trip_status}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    driver_number: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Vacationlist">
                                Vacation List
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Vacationlist"
                                value={leadfilterData.vacation_list}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    vacation_list: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="helpdoc">Help Doc</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="helpdoc"
                                value={leadfilterData.help_doc}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    help_doc: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="flightstaus">
                                Flight Status
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="flightstaus"
                                value={leadfilterData.flight_status}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    flight_status: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="DC">Double Check</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="CF"
                                value={leadfilterData.double_check}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    double_check: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 480,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="sourceairport">
                                Source Airport (Airport code only)
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                displayEmpty
                                labelId="sourceairport"
                                value={leadfilterData.lead_source_airport}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    lead_source_airport: e.target.value,
                                  })
                                }
                                inputProps={{
                                  className: classes.input,
                                  pattern: "[A-Z]{3}",
                                }}
                                InputLabelProps={{ shrink: true }}
                              >
                                <MenuItem value={"DNK"}>DNK</MenuItem>
                                {airportlist2.map((data) => (
                                  <MenuItem value={data.airport}>
                                    {data.airport}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </FormGroup>
                        </div>
                      ) : (
                        ""
                      )}
                      <br></br>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={changeisOwner}
                      >
                        {isOwner ? "Show All" : "Show Owner"}{" "}
                      </Button>
                      <Button
                        variant="contained"
                        color="inherit"
                        className={classes.button}
                        onClick={changeshowfilter}
                      >
                        {showfilter ? "Hide Filters" : "Show Filters"}{" "}
                      </Button>
                      <Button
                        variant="contained"
                        color="inherit"
                        className={classes.button}
                        onClick={changeshowtrips}
                      >
                        {showtrips
                          ? "Show 90 day Trips"
                          : "Show All Trips"}{" "}
                      </Button>
                      <Button
                        href="/searchtrip"
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                      >
                        Search Trips
                      </Button>
                    </div>
                    {tripdatalistdisplay.length > 1 ? (
                      <div>
                        <CSVLink data={tripdatalistdisplay} headers={headers3}>
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 800, width: "100%" }}>
                      {/* <div
            
            style={{
              // flex: col.flex || 1,
              display: 'flex',
              flexDirection: 'row',
              position: "sticky",
              top: "0",
              zIndex: "2",
              fontWeight: 'bold',
            }}
          >
        {columns.map((col) => (
          <div
            key={col.field}
            style={{
              
              width: col.width,
              
            }}
          >
            {col.field}
            </div>
        ))}
        </div> */}
                      <DataTable
                        value={tripdatalistdisplay}
                        showGridlines
                        size="large"
                        scrollable
                        scrollHeight="800px"
                        stripedRows
                        paginator
                        rows={40}
                        paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        paginatorLeft={paginatorLeft}
                        paginatorRight={paginatorRight}
                        filters={filters}
                        globalFilterFields={[
                          "name",
                          "country.name",
                          "representative.name",
                          "balance",
                          "status",
                        ]}
                        emptyMessage="No trips found."
                        onFilter={(e) => setFilters(e.filters)}
                        // multiSortMeta={multiSortMeta}
                        rowStyle={rowClassName}
                        sortMode="multiple"
                        resizableColumns
                        columnResizeMode="expand"
                        onRowDoubleClick={(e) => onRowDoubleClick(e.data)}
                        tableStyle={{ minWidth: "50rem" }}
                      >
                        <Column
                          field="trip_id"
                          sortable
                          header="Trip Id"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="cust_name"
                          sortable
                          header="Name"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        {/* <Column field="trip_start_date" sortable header="Trip Start Date" style={{ width: '200px' }} dataType="date" filterField="date" filter filterElement={dateFilterTemplate}></Column> */}
                        <Column
                          field="trip_start_date"
                          sortable
                          header="Trip Start Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="primary_destination"
                          sortable
                          header="Destination"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="trip_end_date"
                          sortable
                          header="End Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="all_good"
                          sortable
                          header="DC"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_flight"
                          sortable
                          header="Flight Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_hotel"
                          sortable
                          header="Hotel Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_land"
                          sortable
                          header="Land Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_visa"
                          sortable
                          header="Visa Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_insurance"
                          sortable
                          header="Insurance Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="book_add"
                          sortable
                          header="Add. Items Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="advance_booking"
                          sortable
                          header="Advance Book"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="hotel_booking_date"
                          sortable
                          header="Hotel Booking Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="task"
                          sortable
                          header="Task"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="bc"
                          sortable
                          header="Briefing Call"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="hp"
                          sortable
                          header="Pitch Hotel"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="ve"
                          sortable
                          header="Voucher Explained"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="inv"
                          sortable
                          header="Invoice Name Matched"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="fup_date"
                          sortable
                          header="Fup Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="ops_owner"
                          sortable
                          header="Ops Owner"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="upsell_ops_owner"
                          sortable
                          header="Upsell Owner"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="trip_owner"
                          sortable
                          header="Trip Owner"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="conv_date"
                          sortable
                          header="Converted On"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="accepted_date"
                          sortable
                          header="Accepted On"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="fup_comment"
                          sortable
                          header="Fup Comment"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                      </DataTable>
                      {/* <DataGrid rows={tripdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
        columns={columns}
       
        autoPageSize
        // autoHeight
        >      
      </DataGrid>       */}
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={1}>
                  <Paper variant="outlined" className={classes.paper}>
                    {tripdatalistdisplay8.length > 1 ? (
                      <div>
                        <CSVLink data={tripdatalistdisplay8} headers={headers5}>
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="ops owner">Ops Owner</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Ops Owner"
                        value={leadfilterData2.ops_owner}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            ops_owner: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>

                        {emp2.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CF">Confirmed Trips</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CF"
                        value={leadfilterData2.future_trips}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            future_trips: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"Without JC"}>Without JC</MenuItem>
                      </Select>
                    </FormControl>
                    {selection.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment2()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay8}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns5}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection(newSelection);
                        }}
                        autoPageSize
                        columnVisibilityModel={columnVisibilityModel2}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel2(newModel)
                        }
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={2}>
                  <Paper variant="outlined" className={classes.paper}>
                    {tripdatalistdisplay7.length > 1 ? (
                      <div>
                        <CSVLink data={tripdatalistdisplay7} headers={headers2}>
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="ops owner">Ops Owner</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Ops Owner"
                        value={leadfilterData3.ops_owner}
                        onChange={(e) =>
                          setleadfilterData3({
                            ...leadfilterData3,
                            ops_owner: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>

                        {emp2.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay7}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns6}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={3}>
                  <Paper variant="outlined" className={classes.paper}>
                    {/* {tripdatalistdisplay10.length>1?(<div>
                   <CSVLink data={tripdatalistdisplay10} headers={headers5}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="ops owner">Ops Owner</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Ops Owner"
                        value={leadfilterData2.ops_owner}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            ops_owner: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>

                        {emp2.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay10}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns5b}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={4}>
                  <Paper variant="outlined" className={classes.paper}>
                    {tripdatalistdisplay13.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay13}
                          headers={headers12b}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}

                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay13}
                        onCellDoubleClick={(getValue) =>
                          gridcellclickpayment(getValue.row.trip_id)
                        }
                        columns={columns12b}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={5}>
                  <Paper variant="outlined" className={classes.paper}>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CF">Confirmed Trips</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CF"
                        value={leadfilterData2.future_trips}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            future_trips: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"Without JC"}>Without JC</MenuItem>
                      </Select>
                    </FormControl>
                    {selection12.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment5()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    {tripdatalistdisplay12.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay12}
                          headers={headers12}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataTable
                        value={tripdatalistdisplay12}
                        showGridlines
                        size="large"
                        scrollable
                        scrollHeight="800px"
                        stripedRows
                        paginator
                        rows={40}
                        paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        paginatorLeft={paginatorLeft}
                        paginatorRight={paginatorRight}
                        filters={filters}
                        globalFilterFields={[
                          "trip_id",
                          "cust_name",
                          "primary_destination",
                          "ops_owner",
                          "upsell_ops_owner",
                        ]}
                        emptyMessage="No trips found."
                        onFilter={(e) => setFilters(e.filters)}
                        rowStyle={rowClassName}
                        sortMode="multiple"
                        resizableColumns
                        columnResizeMode="expand"
                        dataKey="id"
                        selectionMode="checkbox"
                        selection={tripdatalistdisplay12.filter((r) =>
                          selection12.includes(r.id),
                        )}
                        onSelectionChange={(e) =>
                          setselection12(e.value.map((r) => r.id))
                        }
                        onRowDoubleClick={(e) => onRowDoubleClick(e.data)}
                        tableStyle={{ minWidth: "50rem" }}
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3rem" }}
                        ></Column>
                        <Column
                          field="trip_id"
                          sortable
                          header="Trip Id"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="cust_name"
                          sortable
                          header="Name"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="trip_start_date"
                          sortable
                          header="Trip Start Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="primary_destination"
                          sortable
                          header="Primary Destination"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="ops_owner"
                          sortable
                          header="Ops Owner"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="upsell_ops_owner"
                          sortable
                          header="Upsell Owner"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="conv_date"
                          sortable
                          header="Conv Date"
                          style={{ width: "200px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="upsell_comment_1"
                          sortable
                          header="Comment 1"
                          style={{ width: "400px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                        <Column
                          field="upsell_comment_2"
                          sortable
                          header="Comment 2"
                          style={{ width: "400px" }}
                          filter
                          filterPlaceholder="Search by text"
                        ></Column>
                      </DataTable>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={6}>
                  <Paper variant="outlined" className={classes.paper}>
                    {selection15.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment8()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    {tripdatalistdisplay15.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay15}
                          headers={headers12c}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay15}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns12c}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection15(newSelection);
                        }}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={7}>
                  <Paper variant="outlined" className={classes.paper}>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="TD">Trip Display</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="TD"
                        value={leadfilterData2.trip_display}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            trip_display: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Show All"}>Show All</MenuItem>
                      </Select>
                    </FormControl>
                    {tripdatalistdisplay6.length > 1 ? (
                      <div>
                        <CSVLink data={tripdatalistdisplay6} headers={headers6}>
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay6}
                        onCellDoubleClick={(getValue) =>
                          gridcellclickpayment(getValue.row.trip_id)
                        }
                        columns={columns5c}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={8}>
                  <Paper variant="outlined" className={classes.paper}>
                    {/* {tripdatalistdisplay4.length>1?(<div>
                   <CSVLink data={tripdatalistdisplay4} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay6b}
                        onCellDoubleClick={(getValue) =>
                          gridcellclickpayment(getValue.row.trip_id)
                        }
                        columns={columns5d}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
              </>
            )}

            {/* ---------- SUB TABS FOR PS ---------- */}
            {mainTab === 1 && (
              <>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tabs
                    value={subTab}
                    onChange={handleSubTabChange}
                    aria-label="ps sub tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    centered
                  >
                    <Tab label="PS Flags" {...a11yProps(0)} />
                    <Tab label="Payment" {...a11yProps(1)} />
                    <Tab label="At risk" {...a11yProps(2)} />
                    <Tab label="Docs" {...a11yProps(3)} />
                    <Tab label="On Ground" {...a11yProps(4)} />
                  </Tabs>
                </Box>

                <TabPanel value={subTab} index={0}>
                  <Paper variant="outlined" className={classes.paper}>
                    <Typography
                      variant="h4"
                      align="center"
                      className={classes.headertext}
                    >
                      {" "}
                      View Converted Trips
                    </Typography>
                    <div align="center">
                      <FormGroup row className={classes.formgroup}>
                        <FormControl
                          style={{
                            minWidth: 480,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="trip owner">Trip Owner</InputLabel>
                          <Select
                            displayEmpty
                            className={classes.textField}
                            InputLabelProps={{ shrink: true }}
                            labelId="Trip Owner"
                            value={leadfilterData.trip_owner}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                trip_owner: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Amit"}>Amit</MenuItem>
                            {emp.map((emp) => {
                              return <MenuItem value={emp}>{emp}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 480,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="ops owner">Ops Owner</InputLabel>
                          <Select
                            displayEmpty
                            className={classes.textField}
                            InputLabelProps={{ shrink: true }}
                            labelId="Ops Owner"
                            value={leadfilterData.ops_owner}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                ops_owner: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>

                            {emp2.map((emp) => {
                              return <MenuItem value={emp}>{emp}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        <FormControl
                          style={{
                            minWidth: 240,
                            marginTop: 16,
                            marginRight: 32,
                            marginLeft: 8,
                          }}
                        >
                          <InputLabel id="TF">Transfer Status</InputLabel>
                          <Select
                            classname={classes.textField}
                            labelId="TF"
                            value={leadfilterData.transfer_status}
                            onChange={(e) =>
                              setleadfilterData({
                                ...leadfilterData,
                                transfer_status: e.target.value,
                              })
                            }
                          >
                            <MenuItem value={""}>Clear</MenuItem>
                            <MenuItem value={"Just Converted"}>
                              Just Converted
                            </MenuItem>
                            <MenuItem value={"Requested"}>Requested</MenuItem>
                            <MenuItem value={"Accepted"}>Accepted</MenuItem>
                            <MenuItem value={"Back to Sales"}>
                              Back to Sales
                            </MenuItem>
                            <MenuItem value={"NA"}>NA</MenuItem>
                          </Select>
                        </FormControl>
                      </FormGroup>
                      {showfilter ? (
                        <div>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Trip Model">
                                Trip Model
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Trip Model"
                                value={leadfilterData.trip_model}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    trip_model: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"B2B"}>B2B</MenuItem>
                                <MenuItem value={"B2C"}>B2C</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="OF">Only Flight</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="OF"
                                value={leadfilterData.only_flight}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    only_flight: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="NoTax">No Tax</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Trip NoTax"
                                value={leadfilterData.no_tax}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    no_tax: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Flight Ticket">
                                Flight Ticket
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Flight Ticket"
                                value={leadfilterData.flight_ticket}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    flight_ticket: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Hotel Voucher">
                                Hotel Voucher
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Hotel Voucher"
                                value={leadfilterData.hotel_voucher}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    hotel_voucher: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Land Voucher">
                                Land Voucher
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Hotel Voucher"
                                value={leadfilterData.land_voucher}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    land_voucher: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Visa">Visa</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Visa"
                                value={leadfilterData.visa}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    visa: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="CheckIn">
                                {" "}
                                Flight CheckIn
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="CheckIn"
                                value={leadfilterData.check_in}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    check_in: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Driver Number">
                                Driver Number
                              </InputLabel>
                              <Select
                                displayEmpty
                                classname={classes.textField}
                                labelId="Driver Number"
                                value={leadfilterData.trip_status}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    driver_number: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="Vacationlist">
                                Vacation List
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="Vacationlist"
                                value={leadfilterData.vacation_list}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    vacation_list: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="helpdoc">Help Doc</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="helpdoc"
                                value={leadfilterData.help_doc}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    help_doc: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="flightstaus">
                                Flight Status
                              </InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="flightstaus"
                                value={leadfilterData.flight_status}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    flight_status: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                                <MenuItem value={"NA"}>NA</MenuItem>
                                <MenuItem value={"NR"}>NR</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                          <FormGroup row className={classes.formgroup}>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="CF">Confirmed Trips</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="CF"
                                value={leadfilterData.future_trips}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    future_trips: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"Without JC"}>
                                  Without JC
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              style={{
                                minWidth: 240,
                                marginTop: 16,
                                marginRight: 32,
                                marginLeft: 8,
                              }}
                            >
                              <InputLabel id="DC">Double Check</InputLabel>
                              <Select
                                classname={classes.textField}
                                labelId="CF"
                                value={leadfilterData.double_check}
                                onChange={(e) =>
                                  setleadfilterData({
                                    ...leadfilterData,
                                    double_check: e.target.value,
                                  })
                                }
                              >
                                <MenuItem value={""}>Clear</MenuItem>
                                <MenuItem value={"Yes"}>Yes</MenuItem>
                                <MenuItem value={"No"}>No</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                        </div>
                      ) : (
                        ""
                      )}
                      <br></br>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={changeisOwner}
                      >
                        {isOwner ? "Show All" : "Show Owner"}{" "}
                      </Button>
                      <Button
                        variant="contained"
                        color="inherit"
                        className={classes.button}
                        onClick={changeshowfilter}
                      >
                        {showfilter ? "Hide Filters" : "Show Filters"}{" "}
                      </Button>
                      <Button
                        variant="contained"
                        color="inherit"
                        className={classes.button}
                        onClick={changeshowtrips}
                      >
                        {showtrips ? "Hide Trips" : "Show Trips"}{" "}
                      </Button>
                      <Button
                        href="/searchtrip"
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                      >
                        Search Trips
                      </Button>
                    </div>
                    {tripdatalistdisplay2.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay2}
                          headers={headers2b}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay2}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns2}
                        autoPageSize
                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel(newModel)
                        }
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={1}>
                  <Paper variant="outlined" className={classes.paper}>
                    {tripdatalistdisplay4.length > 1 ? (
                      <div>
                        <CSVLink data={tripdatalistdisplay4} headers={headers}>
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="ops owner">Ops Owner</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Ops Owner"
                        value={leadfilterData2.ops_owner}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            ops_owner: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>

                        {emp2.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay4}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns4}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={2}>
                  <Paper variant="outlined" className={classes.paper}>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CF">Confirmed Trips</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CF"
                        value={leadfilterData6.future_trips}
                        onChange={(e) =>
                          setleadfilterData6({
                            ...leadfilterData6,
                            future_trips: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"Without JC"}>Without JC</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="3D">3 Days</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="3D"
                        value={leadfilterData6.threedays}
                        onChange={(e) =>
                          setleadfilterData6({
                            ...leadfilterData6,
                            threedays: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="10D">10 Days</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="10D"
                        value={leadfilterData6.tendays}
                        onChange={(e) =>
                          setleadfilterData6({
                            ...leadfilterData6,
                            tendays: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                      </Select>
                    </FormControl>
                    {selection4.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment6()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay5}
                        onCellDoubleClick={(getValue) =>
                          gridcellclickpayment(getValue.row.trip_id)
                        }
                        columns={columns4}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection4(newSelection);
                        }}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={3}>
                  <Paper variant="outlined" className={classes.paper}>
                    <div style={{ height: 2400, width: "100%" }}>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="TF">Transfer Status</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="TF"
                          value={leadfilterData2.transfer_status}
                          onChange={(e) =>
                            setleadfilterData2({
                              ...leadfilterData2,
                              transfer_state: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Just Converted"}>
                            Just Converted
                          </MenuItem>
                          <MenuItem value={"Requested"}>Requested</MenuItem>
                          <MenuItem value={"Accepted"}>Accepted</MenuItem>
                          <MenuItem value={"Back to Sales"}>
                            Back to Sales
                          </MenuItem>
                          <MenuItem value={"NA"}>NA</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="OH">On Hold</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="OH"
                          value={leadfilterData2.on_hold}
                          onChange={(e) =>
                            setleadfilterData2({
                              ...leadfilterData2,
                              on_hold: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"No"}>No</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="ops owner">Ops Owner</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Ops Owner"
                          value={leadfilterData2.ops_owner}
                          onChange={(e) =>
                            setleadfilterData2({
                              ...leadfilterData2,
                              ops_owner: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>

                          {emp2.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="CF">Confirmed Trips</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="CF"
                          value={leadfilterData2.future_trips}
                          onChange={(e) =>
                            setleadfilterData2({
                              ...leadfilterData2,
                              future_trips: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                          <MenuItem value={"Without JC"}>Without JC</MenuItem>
                        </Select>
                      </FormControl>
                      {selection2.length > 0 ? (
                        <Button
                          variant="contained"
                          color="Inherit"
                          className={classes.button}
                          onClick={() => updatecomment3()}
                        >
                          Comment
                        </Button>
                      ) : (
                        ""
                      )}
                      <DataGrid
                        rows={tripdatalistdisplay9}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns7}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection2(newSelection);
                        }}
                        autoPageSize
                        columnVisibilityModel={columnVisibilityModel3}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel3(newModel)
                        }
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={4}>
                  <Paper variant="outlined" className={classes.paper}>
                    {selection14.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment7()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}

                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay14}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns14}
                        autoPageSize
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection14(newSelection);
                        }}
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
              </>
            )}

            {/* ---------- SUB TABS FOR REPORTS ---------- */}
            {mainTab === 2 && (
              <>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tabs
                    value={subTab}
                    onChange={handleSubTabChange}
                    aria-label="reports sub tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    centered
                  >
                    <Tab label="D-15 trips" {...a11yProps(0)} />
                    <Tab label="Task Analytics" {...a11yProps(1)} />
                  </Tabs>
                </Box>

                <TabPanel value={subTab} index={1}>
                  <div align="center">
                    <Typography
                      variant="h4"
                      align="center"
                      className={classes.headertext}
                    >
                      {" "}
                      Task
                    </Typography>
                    <TextField
                      variant="outlined"
                      type="date"
                      label="Created On or after"
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        setsearchData8({
                          ...searchData8,
                          start_date: e.target.value,
                        })
                      }
                    />
                    <TextField
                      variant="outlined"
                      type="date"
                      label="Created On or before"
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        setsearchData8({
                          ...searchData8,
                          end_date: e.target.value,
                        })
                      }
                    />
                    <Button
                      onClick={() => fetchtasksbydate()}
                      color="secondary"
                      variant="contained"
                      className={classes.button}
                    >
                      Search
                    </Button>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={handleChange2}
                          color="secondary"
                          label="Search all"
                        />
                      }
                      label="Search All"
                    />
                    <div align="center">
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel>Task Status</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Task Status"
                          value={leadfilterData5.status}
                          onChange={(e) =>
                            setleadfilterData5({
                              ...leadfilterData5,
                              status: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Open"}>Open</MenuItem>
                          <MenuItem value={"Waiting"}>Waiting</MenuItem>
                          <MenuItem value={"Task Done"}>Task Done</MenuItem>
                          <MenuItem value={"In Progress"}>In Progress</MenuItem>
                          <MenuItem value={"Without Task Done"}>
                            Without Task Done
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel>Task Assigned To</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Assigned To"
                          value={leadfilterData5.assigned_to}
                          onChange={(e) =>
                            setleadfilterData5({
                              ...leadfilterData5,
                              assigned_to: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Accounts"}>Accounts</MenuItem>
                          <MenuItem value={"Operations"}>Operations</MenuItem>
                          <MenuItem value={"Support"}>Support</MenuItem>
                          <MenuItem value={"HR"}>HR</MenuItem>
                          <MenuItem value={"Sales"}>Sales</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel>Days Elapsed</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Days Elapsed"
                          value={leadfilterData5.days_elapsed}
                          onChange={(e) =>
                            setleadfilterData5({
                              ...leadfilterData5,
                              days_elapsed: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"0-1"}>0-1</MenuItem>
                          <MenuItem value={"1-2"}>1-2</MenuItem>
                          <MenuItem value={"2-3"}>2-3</MenuItem>
                          <MenuItem value={"3-7"}>3-7</MenuItem>
                          <MenuItem value={"7+"}>7+</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel>Priority</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Priority"
                          value={leadfilterData5.Priority}
                          onChange={(e) =>
                            setleadfilterData5({
                              ...leadfilterData5,
                              priority: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"P1"}>P1</MenuItem>
                          <MenuItem value={"P2"}>P2</MenuItem>
                          <MenuItem value={"P3"}>P3</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="tl">TL</InputLabel>
                        <Select
                          displayEmpty
                          classname={classes.textField}
                          labelId="tl"
                          value={leadfilterData5.tl}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setleadfilterData5({
                              ...leadfilterData5,
                              tl: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          {tlemp.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <br></br>
                  <br></br>
                  <br></br>
                  <div align="center">
                    <TextField
                      variant="outlined"
                      label="Enter trip id:"
                      InputLabelProps={{ shrink: true }}
                      value={leadfilterData4.tour_id}
                      className={classes.textField}
                      onChange={(e) =>
                        setleadfilterData4({
                          ...leadfilterData4,
                          tour_id: e.target.value,
                        })
                      }
                    />
                    <Button
                      onClick={() => searchtaskbytourid()}
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                    >
                      Fetch
                    </Button>
                  </div>
                  {taskdatalistdisplay.length > 1 ? (
                    <div>
                      <CSVLink data={taskdatalistdisplay} headers={headers8}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <Paper variant="outlined" className={classes.paper}>
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={taskdatalistdisplay}
                        onCellDoubleClick={(getValue) =>
                          gridcellclicktask(getValue.row.task_id)
                        }
                        columns={columns8}
                        // pageSize={40}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                  <Paper variant="outlined" className={classes.paper}>
                    <div style={{ height: 500, width: "100%" }}>
                      <DataGrid
                        rows={taskdatalistdisplay2}
                        columns={columns8b}
                        autoPageSize
                      ></DataGrid>
                    </div>
                  </Paper>
                  <Paper variant="outlined" className={classes.paper}>
                    <div style={{ height: 500, width: "100%" }}>
                      <DataGrid
                        rows={taskdatalistdisplay3}
                        columns={columns8c}
                        autoPageSize
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel value={subTab} index={0}>
                  <Paper variant="outlined" className={classes.paper}>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CF">Confirmed Trips</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CF"
                        value={leadfilterData.future_trips}
                        onChange={(e) =>
                          setleadfilterData({
                            ...leadfilterData,
                            future_trips: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"Without JC"}>Without JC</MenuItem>
                      </Select>
                    </FormControl>
                    {tripdatalistdisplay3.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay3}
                          headers={headers3b}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay3}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns3}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection3(newSelection);
                        }}
                        autoPageSize
                        columnVisibilityModel={columnVisibilityModel4}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel4(newModel)
                        }
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
              </>
            )}

            {/* ---------- SUB TABS FOR FINANCE ---------- */}
            {mainTab === 3 && (
              <>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tabs
                    value={subTab}
                    onChange={handleSubTabChange}
                    aria-label="finance sub tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    centered
                  >
                    <Tab label="B2S" {...a11yProps(0)} />
                  </Tabs>
                </Box>

                <TabPanel value={subTab} index={0}>
                  <Paper variant="outlined" className={classes.paper}>
                    {selection11.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment4()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    {tripdatalistdisplay11.length > 1 ? (
                      <div>
                        <CSVLink
                          data={tripdatalistdisplay11}
                          headers={headers11}
                        >
                          Download CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}
                    <div style={{ height: 2400, width: "100%" }}>
                      <DataGrid
                        rows={tripdatalistdisplay11}
                        onCellDoubleClick={(getValue) =>
                          gridcellclick(getValue.row.trip_id)
                        }
                        columns={columns11}
                        checkboxSelection={true}
                        onSelectionModelChange={(newSelection) => {
                          setselection11(newSelection);
                        }}
                        autoPageSize
                        // autoHeight
                      ></DataGrid>
                    </div>
                  </Paper>
                </TabPanel>
              </>
            )}
          </Box>

          {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          <Tab label="Ops flags" {...a11yProps(0)} /> Ops
          <Tab label="PS flags" {...a11yProps(1)} /> CX
          <Tab label="D-15 trips" {...a11yProps(2)} /> All
          <Tab label="Payment" {...a11yProps(3)} /> CX
          <Tab label="At risk" {...a11yProps(4)} /> CX
          <Tab label="Hotel Portal" {...a11yProps(5)} /> Ops
          <Tab label="Daily Task" {...a11yProps(6)} /> Ops
          <Tab label="Visa" {...a11yProps(7)} /> Ops
          <Tab label="Docs" {...a11yProps(8)} /> CX
          <Tab label="Task Analytics" {...a11yProps(9)} /> All
          <Tab label="Hold Operations" {...a11yProps(10)} /> Ops
          <Tab label="B2S" {...a11yProps(11)} /> Others
          <Tab label="Upsell" {...a11yProps(12)} /> Ops
          <Tab label="Cut Off" {...a11yProps(13)} /> Ops
          <Tab label="On Ground" {...a11yProps(14)} /> CX
          <Tab label="Ops Profit" {...a11yProps(15)} /> Ops
        </Tabs>
      </Box> */}

          {/* <div align="center">
        <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="tabs">Tabs</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="tabs" value={value} onChange={(e)=> handleChange(e, value)}>
                <MenuItem value={"Ops flags"}>Ops flags</MenuItem>
                <MenuItem value={"PS flags"}>PS flags</MenuItem>
                
              
                    
                
                </Select>
                </FormControl>
      </div> */}
          {refresh ? (
            <div>
              <TabPanel value={value} index={0}>
                <Paper variant="outlined" className={classes.paper}>
                  <Typography
                    variant="h4"
                    align="center"
                    className={classes.headertext}
                  >
                    {" "}
                    View Converted Trips
                  </Typography>
                  <div align="center">
                    <FormGroup row className={classes.formgroup}>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="trip owner">Trip Owner</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Trip Owner"
                          value={leadfilterData.trip_owner}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              trip_owner: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Amit"}>Amit</MenuItem>
                          {emp.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="ops owner">Ops Owner</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Ops Owner"
                          value={leadfilterData.ops_owner}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              ops_owner: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>

                          {emp2.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="TF">Transfer Status</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="TF"
                          value={leadfilterData.transfer_status}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              transfer_status: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Just Converted"}>
                            Just Converted
                          </MenuItem>
                          <MenuItem value={"Requested"}>Requested</MenuItem>
                          <MenuItem value={"Accepted"}>Accepted</MenuItem>
                          <MenuItem value={"Back to Sales"}>
                            Back to Sales
                          </MenuItem>
                          <MenuItem value={"Non B2S"}>Non B2S</MenuItem>
                          <MenuItem value={"NA"}>NA</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="CF">Confirmed Trips</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="CF"
                          value={leadfilterData.future_trips}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              future_trips: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                          <MenuItem value={"Without JC"}>Without JC</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="3D">3 Days</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="3D"
                          value={leadfilterData.threedays}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              threedays: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                    <br></br>
                    <br></br>
                    {role == "Admin" ||
                    role == "Product" ||
                    role == "Operations-TL" ? (
                      <div align="center">
                        <FormGroup row className={classes.formgroup}>
                          <div align="center">
                            <TextField
                              variant="outlined"
                              label="Enter tour id:"
                              InputLabelProps={{ shrink: true }}
                              value={leadfilterData.tour_id}
                              className={classes.textField}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  tour_id: e.target.value,
                                })
                              }
                            />
                            <Button
                              onClick={() => searchtripbytourid()}
                              variant="contained"
                              color="secondary"
                              className={classes.button}
                            >
                              Fetch
                            </Button>
                          </div>
                          <div align="center">
                            <TextField
                              variant="outlined"
                              label="Enter hotel id:"
                              InputLabelProps={{ shrink: true }}
                              value={leadfilterData.hotel_id}
                              className={classes.textField}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  hotel_id: e.target.value,
                                })
                              }
                            />
                            <Button
                              onClick={() => searchtripbyhotelid()}
                              variant="contained"
                              color="secondary"
                              className={classes.button}
                            >
                              Fetch
                            </Button>
                          </div>
                        </FormGroup>
                      </div>
                    ) : (
                      ""
                    )}
                    {showfilter ? (
                      <div>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Trip Model">Trip Model</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Trip Model"
                              value={leadfilterData.trip_model}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  trip_model: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"B2B"}>B2B</MenuItem>
                              <MenuItem value={"B2C"}>B2C</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="OF">Only Flight</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="OF"
                              value={leadfilterData.only_flight}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  only_flight: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="NoTax">No Tax</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Trip NoTax"
                              value={leadfilterData.no_tax}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  no_tax: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Flight Ticket">
                              Flight Ticket
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Flight Ticket"
                              value={leadfilterData.flight_ticket}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  flight_ticket: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Hotel Voucher">
                              Hotel Voucher
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Hotel Voucher"
                              value={leadfilterData.hotel_voucher}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  hotel_voucher: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Land Voucher">
                              Land Voucher
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Hotel Voucher"
                              value={leadfilterData.land_voucher}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  land_voucher: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Visa">Visa</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Visa"
                              value={leadfilterData.visa}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  visa: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="CheckIn">
                              {" "}
                              Flight CheckIn
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="CheckIn"
                              value={leadfilterData.check_in}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  check_in: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Driver Number">
                              Driver Number
                            </InputLabel>
                            <Select
                              displayEmpty
                              classname={classes.textField}
                              labelId="Driver Number"
                              value={leadfilterData.trip_status}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  driver_number: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Vacationlist">
                              Vacation List
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Vacationlist"
                              value={leadfilterData.vacation_list}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  vacation_list: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="helpdoc">Help Doc</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="helpdoc"
                              value={leadfilterData.help_doc}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  help_doc: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="flightstaus">
                              Flight Status
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="flightstaus"
                              value={leadfilterData.flight_status}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  flight_status: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="DC">Double Check</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="CF"
                              value={leadfilterData.double_check}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  double_check: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 480,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="sourceairport">
                              Source Airport (Airport code only)
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              displayEmpty
                              labelId="sourceairport"
                              value={leadfilterData.lead_source_airport}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  lead_source_airport: e.target.value,
                                })
                              }
                              inputProps={{
                                className: classes.input,
                                pattern: "[A-Z]{3}",
                              }}
                              InputLabelProps={{ shrink: true }}
                            >
                              <MenuItem value={"DNK"}>DNK</MenuItem>
                              {airportlist2.map((data) => (
                                <MenuItem value={data.airport}>
                                  {data.airport}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </FormGroup>
                      </div>
                    ) : (
                      ""
                    )}
                    <br></br>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={changeisOwner}
                    >
                      {isOwner ? "Show All" : "Show Owner"}{" "}
                    </Button>
                    <Button
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                      onClick={changeshowfilter}
                    >
                      {showfilter ? "Hide Filters" : "Show Filters"}{" "}
                    </Button>
                    <Button
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                      onClick={changeshowtrips}
                    >
                      {showtrips ? "Show 90 day Trips" : "Show All Trips"}{" "}
                    </Button>
                    <Button
                      href="/searchtrip"
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                    >
                      Search Trips
                    </Button>
                  </div>
                  {tripdatalistdisplay.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay} headers={headers3}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 800, width: "100%" }}>
                    {/* <div
            
            style={{
              // flex: col.flex || 1,
              display: 'flex',
              flexDirection: 'row',
              position: "sticky",
              top: "0",
              zIndex: "2",
              fontWeight: 'bold',
            }}
          >
        {columns.map((col) => (
          <div
            key={col.field}
            style={{
              
              width: col.width,
              
            }}
          >
            {col.field}
            </div>
        ))}
        </div> */}
                    <DataTable
                      value={tripdatalistdisplay}
                      showGridlines
                      size="large"
                      scrollable
                      scrollHeight="800px"
                      stripedRows
                      paginator
                      rows={40}
                      paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      paginatorLeft={paginatorLeft}
                      paginatorRight={paginatorRight}
                      filters={filters}
                      globalFilterFields={[
                        "name",
                        "country.name",
                        "representative.name",
                        "balance",
                        "status",
                      ]}
                      emptyMessage="No trips found."
                      onFilter={(e) => setFilters(e.filters)}
                      // multiSortMeta={multiSortMeta}
                      rowStyle={rowClassName}
                      sortMode="multiple"
                      resizableColumns
                      columnResizeMode="expand"
                      onRowDoubleClick={(e) => onRowDoubleClick(e.data)}
                      tableStyle={{ minWidth: "50rem" }}
                    >
                      <Column
                        field="trip_id"
                        sortable
                        header="Trip Id"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="cust_name"
                        sortable
                        header="Name"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      {/* <Column field="trip_start_date" sortable header="Trip Start Date" style={{ width: '200px' }} dataType="date" filterField="date" filter filterElement={dateFilterTemplate}></Column> */}
                      <Column
                        field="trip_start_date"
                        sortable
                        header="Trip Start Date"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="primary_destination"
                        sortable
                        header="Destination"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="trip_end_date"
                        sortable
                        header="End Date"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="all_good"
                        sortable
                        header="DC"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_flight"
                        sortable
                        header="Flight Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_hotel"
                        sortable
                        header="Hotel Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_land"
                        sortable
                        header="Land Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_visa"
                        sortable
                        header="Visa Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_insurance"
                        sortable
                        header="Insurance Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="book_add"
                        sortable
                        header="Add. Items Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="advance_booking"
                        sortable
                        header="Advance Book"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="vm"
                        sortable
                        header="Voucher Matched"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="ve"
                        sortable
                        header="Voucher Explained"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="inv"
                        sortable
                        header="Invoice Name Matched"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="fup_date"
                        sortable
                        header="Fup Date"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="ops_owner"
                        sortable
                        header="Ops Owner"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="trip_owner"
                        sortable
                        header="Trip Owner"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="conv_date"
                        sortable
                        header="Converted On"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="accepted_date"
                        sortable
                        header="Accepted On"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                      <Column
                        field="red_flag"
                        sortable
                        header="Red Flag"
                        style={{ width: "200px" }}
                        filter
                        filterPlaceholder="Search by text"
                      ></Column>
                    </DataTable>
                    {/* <DataGrid rows={tripdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
        columns={columns}
       
        autoPageSize
        // autoHeight
        >      
      </DataGrid>       */}
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Paper variant="outlined" className={classes.paper}>
                  <Typography
                    variant="h4"
                    align="center"
                    className={classes.headertext}
                  >
                    {" "}
                    View Converted Trips
                  </Typography>
                  <div align="center">
                    <FormGroup row className={classes.formgroup}>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="trip owner">Trip Owner</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Trip Owner"
                          value={leadfilterData.trip_owner}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              trip_owner: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Amit"}>Amit</MenuItem>
                          {emp.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 480,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="ops owner">Ops Owner</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          labelId="Ops Owner"
                          value={leadfilterData.ops_owner}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              ops_owner: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>

                          {emp2.map((emp) => {
                            return <MenuItem value={emp}>{emp}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        style={{
                          minWidth: 240,
                          marginTop: 16,
                          marginRight: 32,
                          marginLeft: 8,
                        }}
                      >
                        <InputLabel id="TF">Transfer Status</InputLabel>
                        <Select
                          classname={classes.textField}
                          labelId="TF"
                          value={leadfilterData.transfer_status}
                          onChange={(e) =>
                            setleadfilterData({
                              ...leadfilterData,
                              transfer_status: e.target.value,
                            })
                          }
                        >
                          <MenuItem value={""}>Clear</MenuItem>
                          <MenuItem value={"Just Converted"}>
                            Just Converted
                          </MenuItem>
                          <MenuItem value={"Requested"}>Requested</MenuItem>
                          <MenuItem value={"Accepted"}>Accepted</MenuItem>
                          <MenuItem value={"Back to Sales"}>
                            Back to Sales
                          </MenuItem>
                          <MenuItem value={"NA"}>NA</MenuItem>
                        </Select>
                      </FormControl>
                    </FormGroup>
                    {showfilter ? (
                      <div>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Trip Model">Trip Model</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Trip Model"
                              value={leadfilterData.trip_model}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  trip_model: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"B2B"}>B2B</MenuItem>
                              <MenuItem value={"B2C"}>B2C</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="OF">Only Flight</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="OF"
                              value={leadfilterData.only_flight}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  only_flight: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="NoTax">No Tax</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Trip NoTax"
                              value={leadfilterData.no_tax}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  no_tax: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Flight Ticket">
                              Flight Ticket
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Flight Ticket"
                              value={leadfilterData.flight_ticket}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  flight_ticket: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Hotel Voucher">
                              Hotel Voucher
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Hotel Voucher"
                              value={leadfilterData.hotel_voucher}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  hotel_voucher: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Land Voucher">
                              Land Voucher
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Hotel Voucher"
                              value={leadfilterData.land_voucher}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  land_voucher: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Visa">Visa</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Visa"
                              value={leadfilterData.visa}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  visa: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="CheckIn">
                              {" "}
                              Flight CheckIn
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="CheckIn"
                              value={leadfilterData.check_in}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  check_in: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Driver Number">
                              Driver Number
                            </InputLabel>
                            <Select
                              displayEmpty
                              classname={classes.textField}
                              labelId="Driver Number"
                              value={leadfilterData.trip_status}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  driver_number: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="Vacationlist">
                              Vacation List
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="Vacationlist"
                              value={leadfilterData.vacation_list}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  vacation_list: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="helpdoc">Help Doc</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="helpdoc"
                              value={leadfilterData.help_doc}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  help_doc: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="flightstaus">
                              Flight Status
                            </InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="flightstaus"
                              value={leadfilterData.flight_status}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  flight_status: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                              <MenuItem value={"NR"}>NR</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                        <FormGroup row className={classes.formgroup}>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="CF">Confirmed Trips</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="CF"
                              value={leadfilterData.future_trips}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  future_trips: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"Without JC"}>
                                Without JC
                              </MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{
                              minWidth: 240,
                              marginTop: 16,
                              marginRight: 32,
                              marginLeft: 8,
                            }}
                          >
                            <InputLabel id="DC">Double Check</InputLabel>
                            <Select
                              classname={classes.textField}
                              labelId="CF"
                              value={leadfilterData.double_check}
                              onChange={(e) =>
                                setleadfilterData({
                                  ...leadfilterData,
                                  double_check: e.target.value,
                                })
                              }
                            >
                              <MenuItem value={""}>Clear</MenuItem>
                              <MenuItem value={"Yes"}>Yes</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                      </div>
                    ) : (
                      ""
                    )}
                    <br></br>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={changeisOwner}
                    >
                      {isOwner ? "Show All" : "Show Owner"}{" "}
                    </Button>
                    <Button
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                      onClick={changeshowfilter}
                    >
                      {showfilter ? "Hide Filters" : "Show Filters"}{" "}
                    </Button>
                    <Button
                      variant="contained"
                      color="inherit"
                      className={classes.button}
                      onClick={changeshowtrips}
                    >
                      {showtrips ? "Hide Trips" : "Show Trips"}{" "}
                    </Button>
                    <Button
                      href="/searchtrip"
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                    >
                      Search Trips
                    </Button>
                  </div>
                  {tripdatalistdisplay2.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay2} headers={headers2b}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay2}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns2}
                      autoPageSize
                      columnVisibilityModel={columnVisibilityModel}
                      onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                      }
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Paper variant="outlined" className={classes.paper}>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay3}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns3}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection3(newSelection);
                      }}
                      autoPageSize
                      columnVisibilityModel={columnVisibilityModel4}
                      onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel4(newModel)
                      }
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Paper variant="outlined" className={classes.paper}>
                  {tripdatalistdisplay4.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay4} headers={headers}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="ops owner">Ops Owner</InputLabel>
                    <Select
                      displayEmpty
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      labelId="Ops Owner"
                      value={leadfilterData2.ops_owner}
                      onChange={(e) =>
                        setleadfilterData2({
                          ...leadfilterData2,
                          ops_owner: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>

                      {emp2.map((emp) => {
                        return <MenuItem value={emp}>{emp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay4}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns4}
                      // pageSize={40}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={4}>
                <Paper variant="outlined" className={classes.paper}>
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="CF">Confirmed Trips</InputLabel>
                    <Select
                      classname={classes.textField}
                      labelId="CF"
                      value={leadfilterData6.future_trips}
                      onChange={(e) =>
                        setleadfilterData6({
                          ...leadfilterData6,
                          future_trips: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"Without JC"}>Without JC</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="3D">3 Days</InputLabel>
                    <Select
                      classname={classes.textField}
                      labelId="3D"
                      value={leadfilterData6.threedays}
                      onChange={(e) =>
                        setleadfilterData6({
                          ...leadfilterData6,
                          threedays: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="10D">10 Days</InputLabel>
                    <Select
                      classname={classes.textField}
                      labelId="10D"
                      value={leadfilterData6.tendays}
                      onChange={(e) =>
                        setleadfilterData6({
                          ...leadfilterData6,
                          tendays: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                  {selection4.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment6()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay5}
                      onCellDoubleClick={(getValue) =>
                        gridcellclickpayment(getValue.row.trip_id)
                      }
                      columns={columns4}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection4(newSelection);
                      }}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={5}>
                <Paper variant="outlined" className={classes.paper}>
                  {/* {tripdatalistdisplay4.length>1?(<div>
                   <CSVLink data={tripdatalistdisplay4} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay6}
                      onCellDoubleClick={(getValue) =>
                        gridcellclickpayment(getValue.row.trip_id)
                      }
                      columns={columns5c}
                      // pageSize={40}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={6}>
                <Paper variant="outlined" className={classes.paper}>
                  {tripdatalistdisplay7.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay7} headers={headers2}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="ops owner">Ops Owner</InputLabel>
                    <Select
                      displayEmpty
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      labelId="Ops Owner"
                      value={leadfilterData3.ops_owner}
                      onChange={(e) =>
                        setleadfilterData3({
                          ...leadfilterData3,
                          ops_owner: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>

                      {emp2.map((emp) => {
                        return <MenuItem value={emp}>{emp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay7}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns6}
                      // pageSize={40}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={7}>
                <Paper variant="outlined" className={classes.paper}>
                  {tripdatalistdisplay8.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay8} headers={headers5}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="ops owner">Ops Owner</InputLabel>
                    <Select
                      displayEmpty
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      labelId="Ops Owner"
                      value={leadfilterData2.ops_owner}
                      onChange={(e) =>
                        setleadfilterData2({
                          ...leadfilterData2,
                          ops_owner: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>

                      {emp2.map((emp) => {
                        return <MenuItem value={emp}>{emp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="CF">Confirmed Trips</InputLabel>
                    <Select
                      classname={classes.textField}
                      labelId="CF"
                      value={leadfilterData2.future_trips}
                      onChange={(e) =>
                        setleadfilterData2({
                          ...leadfilterData2,
                          future_trips: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"Without JC"}>Without JC</MenuItem>
                    </Select>
                  </FormControl>
                  {selection.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment2()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay8}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns5}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection(newSelection);
                      }}
                      autoPageSize
                      columnVisibilityModel={columnVisibilityModel2}
                      onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel2(newModel)
                      }
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={8}>
                <Paper variant="outlined" className={classes.paper}>
                  <div style={{ height: 2400, width: "100%" }}>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="TF">Transfer Status</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="TF"
                        value={leadfilterData2.transfer_status}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            transfer_state: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Just Converted"}>
                          Just Converted
                        </MenuItem>
                        <MenuItem value={"Requested"}>Requested</MenuItem>
                        <MenuItem value={"Accepted"}>Accepted</MenuItem>
                        <MenuItem value={"Back to Sales"}>
                          Back to Sales
                        </MenuItem>
                        <MenuItem value={"NA"}>NA</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="OH">On Hold</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="OH"
                        value={leadfilterData2.on_hold}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            on_hold: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="ops owner">Ops Owner</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Ops Owner"
                        value={leadfilterData2.ops_owner}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            ops_owner: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>

                        {emp2.map((emp) => {
                          return <MenuItem value={emp}>{emp}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="CF">Confirmed Trips</InputLabel>
                      <Select
                        classname={classes.textField}
                        labelId="CF"
                        value={leadfilterData2.future_trips}
                        onChange={(e) =>
                          setleadfilterData2({
                            ...leadfilterData2,
                            future_trips: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"Without JC"}>Without JC</MenuItem>
                      </Select>
                    </FormControl>
                    {selection2.length > 0 ? (
                      <Button
                        variant="contained"
                        color="Inherit"
                        className={classes.button}
                        onClick={() => updatecomment3()}
                      >
                        Comment
                      </Button>
                    ) : (
                      ""
                    )}
                    <DataGrid
                      rows={tripdatalistdisplay9}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns7}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection2(newSelection);
                      }}
                      autoPageSize
                      columnVisibilityModel={columnVisibilityModel3}
                      onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel3(newModel)
                      }
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={9}>
                <div align="center">
                  <Typography
                    variant="h4"
                    align="center"
                    className={classes.headertext}
                  >
                    {" "}
                    Task
                  </Typography>
                  <TextField
                    variant="outlined"
                    type="date"
                    label="Created On or after"
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setsearchData8({
                        ...searchData8,
                        start_date: e.target.value,
                      })
                    }
                  />
                  <TextField
                    variant="outlined"
                    type="date"
                    label="Created On or before"
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setsearchData8({
                        ...searchData8,
                        end_date: e.target.value,
                      })
                    }
                  />
                  <Button
                    onClick={() => fetchtasksbydate()}
                    color="secondary"
                    variant="contained"
                    className={classes.button}
                  >
                    Search
                  </Button>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={handleChange2}
                        color="secondary"
                        label="Search all"
                      />
                    }
                    label="Search All"
                  />
                  <div align="center">
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel>Task Status</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Task Status"
                        value={leadfilterData5.status}
                        onChange={(e) =>
                          setleadfilterData5({
                            ...leadfilterData5,
                            status: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Open"}>Open</MenuItem>
                        <MenuItem value={"Waiting"}>Waiting</MenuItem>
                        <MenuItem value={"Task Done"}>Task Done</MenuItem>
                        <MenuItem value={"In Progres"}>In Progress</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel>Task Assigned To</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Assigned To"
                        value={leadfilterData5.assigned_to}
                        onChange={(e) =>
                          setleadfilterData5({
                            ...leadfilterData5,
                            assigned_to: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"Accounts"}>Accounts</MenuItem>
                        <MenuItem value={"Operations"}>Operations</MenuItem>
                        <MenuItem value={"Support"}>Support</MenuItem>
                        <MenuItem value={"HR"}>HR</MenuItem>
                        <MenuItem value={"Sales"}>Sales</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 240,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel>Days Elapsed</InputLabel>
                      <Select
                        displayEmpty
                        className={classes.textField}
                        InputLabelProps={{ shrink: true }}
                        labelId="Days Elapsed"
                        value={leadfilterData5.days_elapsed}
                        onChange={(e) =>
                          setleadfilterData5({
                            ...leadfilterData5,
                            days_elapsed: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        <MenuItem value={"0-1"}>0-1</MenuItem>
                        <MenuItem value={"1-2"}>1-2</MenuItem>
                        <MenuItem value={"2-3"}>2-3</MenuItem>
                        <MenuItem value={"3-7"}>3-7</MenuItem>
                        <MenuItem value={"7+"}>7+</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="tl">TL (ticket data)</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="tl"
                        value={leadfilterData5.tl}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) =>
                          setleadfilterData5({
                            ...leadfilterData5,
                            tl: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={""}>Clear</MenuItem>
                        {emp2.map((emp) => {
                          return (
                            <MenuItem value={emp.short_name}>
                              {emp.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <div align="center">
                  <TextField
                    variant="outlined"
                    label="Enter tour id:"
                    InputLabelProps={{ shrink: true }}
                    value={leadfilterData4.tour_id}
                    className={classes.textField}
                    onChange={(e) =>
                      setleadfilterData4({
                        ...leadfilterData4,
                        tour_id: e.target.value,
                      })
                    }
                  />
                  <Button
                    onClick={() => searchtaskbytourid()}
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                  >
                    Fetch
                  </Button>
                </div>
                {taskdatalistdisplay.length > 1 ? (
                  <div>
                    <CSVLink data={taskdatalistdisplay} headers={headers8}>
                      Download CSV
                    </CSVLink>
                  </div>
                ) : (
                  ""
                )}
                <Paper variant="outlined" className={classes.paper}>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={taskdatalistdisplay}
                      onCellDoubleClick={(getValue) =>
                        gridcellclicktask(getValue.row.task_id)
                      }
                      columns={columns8}
                      // pageSize={40}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
                <Paper variant="outlined" className={classes.paper}>
                  <div style={{ height: 500, width: "100%" }}>
                    <DataGrid
                      rows={taskdatalistdisplay2}
                      columns={columns8b}
                      autoPageSize
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={10}>
                <Paper variant="outlined" className={classes.paper}>
                  {/* {tripdatalistdisplay10.length>1?(<div>
                   <CSVLink data={tripdatalistdisplay10} headers={headers5}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="ops owner">Ops Owner</InputLabel>
                    <Select
                      displayEmpty
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                      labelId="Ops Owner"
                      value={leadfilterData2.ops_owner}
                      onChange={(e) =>
                        setleadfilterData2({
                          ...leadfilterData2,
                          ops_owner: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={""}>Clear</MenuItem>

                      {emp2.map((emp) => {
                        return <MenuItem value={emp}>{emp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay10}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns5b}
                      // pageSize={40}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={11}>
                <Paper variant="outlined" className={classes.paper}>
                  {selection11.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment4()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}
                  {tripdatalistdisplay11.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay11} headers={headers11}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay11}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns11}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection11(newSelection);
                      }}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={12}>
                <Paper variant="outlined" className={classes.paper}>
                  {selection12.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment5()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}
                  {tripdatalistdisplay12.length > 1 ? (
                    <div>
                      <CSVLink data={tripdatalistdisplay12} headers={headers12}>
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay12}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns12}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection12(newSelection);
                      }}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={13}>
                <Paper variant="outlined" className={classes.paper}>
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay13}
                      onCellDoubleClick={(getValue) =>
                        gridcellclickpayment(getValue.row.trip_id)
                      }
                      columns={columns12}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={14}>
                <Paper variant="outlined" className={classes.paper}>
                  {selection14.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment7()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}

                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay14}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns14}
                      autoPageSize
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection14(newSelection);
                      }}
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
              <TabPanel value={value} index={15}>
                <Paper variant="outlined" className={classes.paper}>
                  {selection15.length > 0 ? (
                    <Button
                      variant="contained"
                      color="Inherit"
                      className={classes.button}
                      onClick={() => updatecomment8()}
                    >
                      Comment
                    </Button>
                  ) : (
                    ""
                  )}
                  {tripdatalistdisplay15.length > 1 ? (
                    <div>
                      <CSVLink
                        data={tripdatalistdisplay15}
                        headers={headers12c}
                      >
                        Download CSV
                      </CSVLink>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ height: 2400, width: "100%" }}>
                    <DataGrid
                      rows={tripdatalistdisplay15}
                      onCellDoubleClick={(getValue) =>
                        gridcellclick(getValue.row.trip_id)
                      }
                      columns={columns12c}
                      checkboxSelection={true}
                      onSelectionModelChange={(newSelection) => {
                        setselection15(newSelection);
                      }}
                      autoPageSize
                      // autoHeight
                    ></DataGrid>
                  </div>
                </Paper>
              </TabPanel>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        "Loading..."
      )}
    </div>
  );
};

export default PostSales;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
